var Xo = Object.defineProperty;
var Qo = (e, n, t) => n in e ? Xo(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var Wn = (e, n, t) => (Qo(e, typeof n != "symbol" ? n + "" : n, t), t);
import Gr, { PureComponent as Go } from "react";
var Dt, q = { exports: {} }, qt = { exports: {} }, H = {}, Lt, zt, Bn, Wt, Bt, Ut, Ht, Yt, Xt, Qt, Un, Gt, Jt, Zt, Q = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function Kt() {
  return zt || (zt = 1, ((e) => {
    process.env.NODE_ENV === "production" ? e.exports = function() {
      if (Dt)
        return H;
      Dt = 1;
      var n = typeof Symbol == "function" && Symbol.for, t = n ? Symbol.for("react.element") : 60103, r = n ? Symbol.for("react.portal") : 60106, o = n ? Symbol.for("react.fragment") : 60107, i = n ? Symbol.for("react.strict_mode") : 60108, s = n ? Symbol.for("react.profiler") : 60114, a = n ? Symbol.for("react.provider") : 60109, u = n ? Symbol.for("react.context") : 60110, c = n ? Symbol.for("react.async_mode") : 60111, h = n ? Symbol.for("react.concurrent_mode") : 60111, l = n ? Symbol.for("react.forward_ref") : 60112, f = n ? Symbol.for("react.suspense") : 60113, y = n ? Symbol.for("react.suspense_list") : 60120, b = n ? Symbol.for("react.memo") : 60115, g = n ? Symbol.for("react.lazy") : 60116, _ = n ? Symbol.for("react.block") : 60121, S = n ? Symbol.for("react.fundamental") : 60117, x = n ? Symbol.for("react.responder") : 60118, C = n ? Symbol.for("react.scope") : 60119;
      function v(p) {
        if (typeof p == "object" && p !== null) {
          var j = p.$$typeof;
          switch (j) {
            case t:
              switch (p = p.type) {
                case c:
                case h:
                case o:
                case s:
                case i:
                case f:
                  return p;
                default:
                  switch (p = p && p.$$typeof) {
                    case u:
                    case l:
                    case g:
                    case b:
                    case a:
                      return p;
                    default:
                      return j;
                  }
              }
            case r:
              return j;
          }
        }
      }
      function d(p) {
        return v(p) === h;
      }
      return H.AsyncMode = c, H.ConcurrentMode = h, H.ContextConsumer = u, H.ContextProvider = a, H.Element = t, H.ForwardRef = l, H.Fragment = o, H.Lazy = g, H.Memo = b, H.Portal = r, H.Profiler = s, H.StrictMode = i, H.Suspense = f, H.isAsyncMode = (p) => d(p) || v(p) === c, H.isConcurrentMode = d, H.isContextConsumer = (p) => v(p) === u, H.isContextProvider = (p) => v(p) === a, H.isElement = (p) => typeof p == "object" && p !== null && p.$$typeof === t, H.isForwardRef = (p) => v(p) === l, H.isFragment = (p) => v(p) === o, H.isLazy = (p) => v(p) === g, H.isMemo = (p) => v(p) === b, H.isPortal = (p) => v(p) === r, H.isProfiler = (p) => v(p) === s, H.isStrictMode = (p) => v(p) === i, H.isSuspense = (p) => v(p) === f, H.isValidElementType = (p) => typeof p == "string" || typeof p == "function" || p === o || p === h || p === s || p === i || p === f || p === y || typeof p == "object" && p !== null && (p.$$typeof === g || p.$$typeof === b || p.$$typeof === a || p.$$typeof === u || p.$$typeof === l || p.$$typeof === S || p.$$typeof === x || p.$$typeof === C || p.$$typeof === _), H.typeOf = v, H;
    }() : e.exports = (Lt || (Lt = 1, process.env.NODE_ENV !== "production" && (() => {
      var n = typeof Symbol == "function" && Symbol.for, t = n ? Symbol.for("react.element") : 60103, r = n ? Symbol.for("react.portal") : 60106, o = n ? Symbol.for("react.fragment") : 60107, i = n ? Symbol.for("react.strict_mode") : 60108, s = n ? Symbol.for("react.profiler") : 60114, a = n ? Symbol.for("react.provider") : 60109, u = n ? Symbol.for("react.context") : 60110, c = n ? Symbol.for("react.async_mode") : 60111, h = n ? Symbol.for("react.concurrent_mode") : 60111, l = n ? Symbol.for("react.forward_ref") : 60112, f = n ? Symbol.for("react.suspense") : 60113, y = n ? Symbol.for("react.suspense_list") : 60120, b = n ? Symbol.for("react.memo") : 60115, g = n ? Symbol.for("react.lazy") : 60116, _ = n ? Symbol.for("react.block") : 60121, S = n ? Symbol.for("react.fundamental") : 60117, x = n ? Symbol.for("react.responder") : 60118, C = n ? Symbol.for("react.scope") : 60119;
      function v(O) {
        if (typeof O == "object" && O !== null) {
          var ne = O.$$typeof;
          switch (ne) {
            case t:
              var ie = O.type;
              switch (ie) {
                case c:
                case h:
                case o:
                case s:
                case i:
                case f:
                  return ie;
                default:
                  var ue = ie && ie.$$typeof;
                  switch (ue) {
                    case u:
                    case l:
                    case g:
                    case b:
                    case a:
                      return ue;
                    default:
                      return ne;
                  }
              }
            case r:
              return ne;
          }
        }
      }
      var d = c, p = h, j = u, M = a, E = t, k = l, I = o, w = g, N = b, R = r, T = s, D = i, F = f, Z = !1;
      function oe(O) {
        return v(O) === h;
      }
      Q.AsyncMode = d, Q.ConcurrentMode = p, Q.ContextConsumer = j, Q.ContextProvider = M, Q.Element = E, Q.ForwardRef = k, Q.Fragment = I, Q.Lazy = w, Q.Memo = N, Q.Portal = R, Q.Profiler = T, Q.StrictMode = D, Q.Suspense = F, Q.isAsyncMode = (O) => (Z || (Z = !0), oe(O) || v(O) === c), Q.isConcurrentMode = oe, Q.isContextConsumer = (O) => v(O) === u, Q.isContextProvider = (O) => v(O) === a, Q.isElement = (O) => typeof O == "object" && O !== null && O.$$typeof === t, Q.isForwardRef = (O) => v(O) === l, Q.isFragment = (O) => v(O) === o, Q.isLazy = (O) => v(O) === g, Q.isMemo = (O) => v(O) === b, Q.isPortal = (O) => v(O) === r, Q.isProfiler = (O) => v(O) === s, Q.isStrictMode = (O) => v(O) === i, Q.isSuspense = (O) => v(O) === f, Q.isValidElementType = (O) => typeof O == "string" || typeof O == "function" || O === o || O === h || O === s || O === i || O === f || O === y || typeof O == "object" && O !== null && (O.$$typeof === g || O.$$typeof === b || O.$$typeof === a || O.$$typeof === u || O.$$typeof === l || O.$$typeof === S || O.$$typeof === x || O.$$typeof === C || O.$$typeof === _), Q.typeOf = v;
    })()), Q);
  })(qt)), qt.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
function Hn() {
  return Ut ? Bt : (Ut = 1, Bt = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
}
function er() {
  return Yt ? Ht : (Yt = 1, Ht = Function.call.bind(Object.prototype.hasOwnProperty));
}
if (process.env.NODE_ENV !== "production") {
  var Jo = Kt();
  q.exports = function() {
    if (Gt)
      return Un;
    Gt = 1;
    var e = Kt(), n = (() => {
      if (Wt)
        return Bn;
      Wt = 1;
      var a = Object.getOwnPropertySymbols, u = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
      function h(l) {
        if (l == null)
          throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(l);
      }
      return Bn = (() => {
        try {
          if (!Object.assign)
            return !1;
          var l = new String("abc");
          if (l[5] = "de", Object.getOwnPropertyNames(l)[0] === "5")
            return !1;
          for (var f = {}, y = 0; y < 10; y++)
            f["_" + String.fromCharCode(y)] = y;
          if (Object.getOwnPropertyNames(f).map((g) => f[g]).join("") !== "0123456789")
            return !1;
          var b = {};
          return "abcdefghijklmnopqrst".split("").forEach((g) => {
            b[g] = g;
          }), Object.keys(Object.assign({}, b)).join("") === "abcdefghijklmnopqrst";
        } catch {
          return !1;
        }
      })() ? Object.assign : function(l, f) {
        for (var y, b, g = h(l), _ = 1; _ < arguments.length; _++) {
          for (var S in y = Object(arguments[_]))
            u.call(y, S) && (g[S] = y[S]);
          if (a) {
            b = a(y);
            for (var x = 0; x < b.length; x++)
              c.call(y, b[x]) && (g[b[x]] = y[b[x]]);
          }
        }
        return g;
      }, Bn;
    })(), t = Hn(), r = er(), o = (() => {
      if (Qt)
        return Xt;
      Qt = 1;
      var a = () => {
      };
      if (process.env.NODE_ENV !== "production") {
        var u = Hn(), c = {}, h = er();
        a = (f) => {
          var y = "Warning: " + f;
          try {
            throw new Error(y);
          } catch {
          }
        };
      }
      function l(f, y, b, g, _) {
        if (process.env.NODE_ENV !== "production") {
          for (var S in f)
            if (h(f, S)) {
              var x;
              try {
                if (typeof f[S] != "function") {
                  var C = Error((g || "React class") + ": " + b + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof f[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw C.name = "Invariant Violation", C;
                }
                x = f[S](y, S, g, b, null, u);
              } catch (d) {
                x = d;
              }
              if (!x || x instanceof Error || a((g || "React class") + ": type specification of " + b + " `" + S + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof x + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), x instanceof Error && !(x.message in c)) {
                c[x.message] = !0;
                var v = _ ? _() : "";
                a("Failed " + b + " type: " + x.message + (v != null ? v : ""));
              }
            }
        }
      }
      return l.resetWarningCache = () => {
        process.env.NODE_ENV !== "production" && (c = {});
      }, Xt = l;
    })(), i = () => {
    };
    function s() {
      return null;
    }
    return process.env.NODE_ENV !== "production" && (i = (a) => {
      var u = "Warning: " + a;
      try {
        throw new Error(u);
      } catch {
      }
    }), Un = function(a, u) {
      var c = typeof Symbol == "function" && Symbol.iterator, h = "<<anonymous>>", l = { array: g("array"), bigint: g("bigint"), bool: g("boolean"), func: g("function"), number: g("number"), object: g("object"), string: g("string"), symbol: g("symbol"), any: b(s), arrayOf: (d) => b((p, j, M, E, k) => {
        if (typeof d != "function")
          return new y("Property `" + k + "` of component `" + M + "` has invalid PropType notation inside arrayOf.");
        var I = p[j];
        if (!Array.isArray(I))
          return new y("Invalid " + E + " `" + k + "` of type `" + x(I) + "` supplied to `" + M + "`, expected an array.");
        for (var w = 0; w < I.length; w++) {
          var N = d(I, w, M, E, k + "[" + w + "]", t);
          if (N instanceof Error)
            return N;
        }
        return null;
      }), element: b((d, p, j, M, E) => {
        var k = d[p];
        return a(k) ? null : new y("Invalid " + M + " `" + E + "` of type `" + x(k) + "` supplied to `" + j + "`, expected a single ReactElement.");
      }), elementType: b((d, p, j, M, E) => {
        var k = d[p];
        return e.isValidElementType(k) ? null : new y("Invalid " + M + " `" + E + "` of type `" + x(k) + "` supplied to `" + j + "`, expected a single ReactElement type.");
      }), instanceOf: (d) => b((p, j, M, E, k) => {
        if (!(p[j] instanceof d)) {
          var I = d.name || h;
          return new y("Invalid " + E + " `" + k + "` of type `" + ((w = p[j]).constructor && w.constructor.name ? w.constructor.name : h) + "` supplied to `" + M + "`, expected instance of `" + I + "`.");
        }
        var w;
        return null;
      }), node: b((d, p, j, M, E) => S(d[p]) ? null : new y("Invalid " + M + " `" + E + "` supplied to `" + j + "`, expected a ReactNode.")), objectOf: (d) => b((p, j, M, E, k) => {
        if (typeof d != "function")
          return new y("Property `" + k + "` of component `" + M + "` has invalid PropType notation inside objectOf.");
        var I = p[j], w = x(I);
        if (w !== "object")
          return new y("Invalid " + E + " `" + k + "` of type `" + w + "` supplied to `" + M + "`, expected an object.");
        for (var N in I)
          if (r(I, N)) {
            var R = d(I, N, M, E, k + "." + N, t);
            if (R instanceof Error)
              return R;
          }
        return null;
      }), oneOf: function(d) {
        if (!Array.isArray(d))
          return process.env.NODE_ENV !== "production" && i(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), s;
        function p(j, M, E, k, I) {
          for (var w = j[M], N = 0; N < d.length; N++)
            if (f(w, d[N]))
              return null;
          var R = JSON.stringify(d, (T, D) => C(D) === "symbol" ? String(D) : D);
          return new y("Invalid " + k + " `" + I + "` of value `" + String(w) + "` supplied to `" + E + "`, expected one of " + R + ".");
        }
        return b(p);
      }, oneOfType: (d) => {
        if (!Array.isArray(d))
          return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), s;
        for (var p = 0; p < d.length; p++) {
          var j = d[p];
          if (typeof j != "function")
            return i("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + v(j) + " at index " + p + "."), s;
        }
        return b((M, E, k, I, w) => {
          for (var N = [], R = 0; R < d.length; R++) {
            var T = (0, d[R])(M, E, k, I, w, t);
            if (T == null)
              return null;
            T.data && r(T.data, "expectedType") && N.push(T.data.expectedType);
          }
          return new y("Invalid " + I + " `" + w + "` supplied to `" + k + "`" + (N.length > 0 ? ", expected one of type [" + N.join(", ") + "]" : "") + ".");
        });
      }, shape: (d) => b((p, j, M, E, k) => {
        var I = p[j], w = x(I);
        if (w !== "object")
          return new y("Invalid " + E + " `" + k + "` of type `" + w + "` supplied to `" + M + "`, expected `object`.");
        for (var N in d) {
          var R = d[N];
          if (typeof R != "function")
            return _(M, E, k, N, C(R));
          var T = R(I, N, M, E, k + "." + N, t);
          if (T)
            return T;
        }
        return null;
      }), exact: (d) => b((p, j, M, E, k) => {
        var I = p[j], w = x(I);
        if (w !== "object")
          return new y("Invalid " + E + " `" + k + "` of type `" + w + "` supplied to `" + M + "`, expected `object`.");
        var N = n({}, p[j], d);
        for (var R in N) {
          var T = d[R];
          if (r(d, R) && typeof T != "function")
            return _(M, E, k, R, C(T));
          if (!T)
            return new y("Invalid " + E + " `" + k + "` key `" + R + "` supplied to `" + M + "`.\nBad object: " + JSON.stringify(p[j], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(d), null, "  "));
          var D = T(I, R, M, E, k + "." + R, t);
          if (D)
            return D;
        }
        return null;
      }) };
      function f(d, p) {
        return d === p ? d !== 0 || 1 / d == 1 / p : d != d && p != p;
      }
      function y(d, p) {
        this.message = d, this.data = p && typeof p == "object" ? p : {}, this.stack = "";
      }
      function b(d) {
        if (process.env.NODE_ENV !== "production")
          var p = {}, j = 0;
        function M(k, I, w, N, R, T, D) {
          if (N = N || h, T = T || w, D !== t) {
            if (u) {
              var F = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
              throw F.name = "Invariant Violation", F;
            }
            if (process.env.NODE_ENV !== "production" && typeof console < "u") {
              var Z = N + ":" + w;
              !p[Z] && j < 3 && (i("You are manually calling a React.PropTypes validation function for the `" + T + "` prop on `" + N + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), p[Z] = !0, j++);
            }
          }
          return I[w] == null ? k ? I[w] === null ? new y("The " + R + " `" + T + "` is marked as required in `" + N + "`, but its value is `null`.") : new y("The " + R + " `" + T + "` is marked as required in `" + N + "`, but its value is `undefined`.") : null : d(I, w, N, R, T);
        }
        var E = M.bind(null, !1);
        return E.isRequired = M.bind(null, !0), E;
      }
      function g(d) {
        return b((p, j, M, E, k, I) => {
          var w = p[j];
          return x(w) !== d ? new y("Invalid " + E + " `" + k + "` of type `" + C(w) + "` supplied to `" + M + "`, expected `" + d + "`.", { expectedType: d }) : null;
        });
      }
      function _(d, p, j, M, E) {
        return new y((d || "React class") + ": " + p + " type `" + j + "." + M + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + E + "`.");
      }
      function S(d) {
        switch (typeof d) {
          case "number":
          case "string":
          case "undefined":
            return !0;
          case "boolean":
            return !d;
          case "object":
            if (Array.isArray(d))
              return d.every(S);
            if (d === null || a(d))
              return !0;
            var p = ((k) => {
              var I = k && (c && k[c] || k["@@iterator"]);
              if (typeof I == "function")
                return I;
            })(d);
            if (!p)
              return !1;
            var j, M = p.call(d);
            if (p !== d.entries) {
              for (; !(j = M.next()).done; )
                if (!S(j.value))
                  return !1;
            } else
              for (; !(j = M.next()).done; ) {
                var E = j.value;
                if (E && !S(E[1]))
                  return !1;
              }
            return !0;
          default:
            return !1;
        }
      }
      function x(d) {
        var p = typeof d;
        return Array.isArray(d) ? "array" : d instanceof RegExp ? "object" : ((j, M) => j === "symbol" || !!M && (M["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && M instanceof Symbol))(p, d) ? "symbol" : p;
      }
      function C(d) {
        if (d == null)
          return "" + d;
        var p = x(d);
        if (p === "object") {
          if (d instanceof Date)
            return "date";
          if (d instanceof RegExp)
            return "regexp";
        }
        return p;
      }
      function v(d) {
        var p = C(d);
        switch (p) {
          case "array":
          case "object":
            return "an " + p;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + p;
          default:
            return p;
        }
      }
      return y.prototype = Error.prototype, l.checkPropTypes = o, l.resetWarningCache = o.resetWarningCache, l.PropTypes = l, l;
    }, Un;
  }()(Jo.isElement, !0);
} else
  q.exports = function() {
    if (Zt)
      return Jt;
    Zt = 1;
    var e = Hn();
    function n() {
    }
    function t() {
    }
    return t.resetWarningCache = n, Jt = () => {
      function r(s, a, u, c, h, l) {
        if (l !== e) {
          var f = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw f.name = "Invariant Violation", f;
        }
      }
      function o() {
        return r;
      }
      r.isRequired = r;
      var i = { array: r, bigint: r, bool: r, func: r, number: r, object: r, string: r, symbol: r, any: r, arrayOf: o, element: r, elementType: r, instanceOf: o, node: r, objectOf: o, oneOf: o, oneOfType: o, shape: o, exact: o, checkPropTypes: t, resetWarningCache: n };
      return i.PropTypes = i, i;
    };
  }()();
function On(e, n) {
  if ((t = (e = n ? e.toExponential(n - 1) : e.toExponential()).indexOf("e")) < 0)
    return null;
  var t, r = e.slice(0, t);
  return [r.length > 1 ? r[0] + r.slice(2) : r, +e.slice(t + 1)];
}
function qe(e) {
  return (e = On(Math.abs(e))) ? e[1] : NaN;
}
var Jr, Zo = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function Mn(e) {
  if (!(n = Zo.exec(e)))
    throw new Error("invalid format: " + e);
  var n;
  return new tt({ fill: n[1], align: n[2], sign: n[3], symbol: n[4], zero: n[5], width: n[6], comma: n[7], precision: n[8] && n[8].slice(1), trim: n[9], type: n[10] });
}
function tt(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
function nr(e, n) {
  var t = On(e, n);
  if (!t)
    return e + "";
  var r = t[0], o = t[1];
  return o < 0 ? "0." + new Array(-o).join("0") + r : r.length > o + 1 ? r.slice(0, o + 1) + "." + r.slice(o + 1) : r + new Array(o - r.length + 2).join("0");
}
Mn.prototype = tt.prototype, tt.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, 0 | this.width)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, 0 | this.precision)) + (this.trim ? "~" : "") + this.type;
};
const tr = { "%": (e, n) => (100 * e).toFixed(n), b: (e) => Math.round(e).toString(2), c: (e) => e + "", d: function(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}, e: (e, n) => e.toExponential(n), f: (e, n) => e.toFixed(n), g: (e, n) => e.toPrecision(n), o: (e) => Math.round(e).toString(8), p: (e, n) => nr(100 * e, n), r: nr, s: function(e, n) {
  var t = On(e, n);
  if (!t)
    return e + "";
  var r = t[0], o = t[1], i = o - (Jr = 3 * Math.max(-8, Math.min(8, Math.floor(o / 3)))) + 1, s = r.length;
  return i === s ? r : i > s ? r + new Array(i - s + 1).join("0") : i > 0 ? r.slice(0, i) + "." + r.slice(i) : "0." + new Array(1 - i).join("0") + On(e, Math.max(0, n + i - 1))[0];
}, X: (e) => Math.round(e).toString(16).toUpperCase(), x: (e) => Math.round(e).toString(16) };
function rr(e) {
  return e;
}
var Yn, jn, Zr, or = Array.prototype.map, ir = ["y", "z", "a", "f", "p", "n", "\xB5", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function Ko(e) {
  var n, t, r = e.grouping === void 0 || e.thousands === void 0 ? rr : (n = or.call(e.grouping, Number), t = e.thousands + "", (f, y) => {
    for (var b = f.length, g = [], _ = 0, S = n[0], x = 0; b > 0 && S > 0 && (x + S + 1 > y && (S = Math.max(1, y - x)), g.push(f.substring(b -= S, b + S)), !((x += S + 1) > y)); )
      S = n[_ = (_ + 1) % n.length];
    return g.reverse().join(t);
  }), o = e.currency === void 0 ? "" : e.currency[0] + "", i = e.currency === void 0 ? "" : e.currency[1] + "", s = e.decimal === void 0 ? "." : e.decimal + "", a = e.numerals === void 0 ? rr : function(f) {
    return (y) => y.replace(/[0-9]/g, (b) => f[+b]);
  }(or.call(e.numerals, String)), u = e.percent === void 0 ? "%" : e.percent + "", c = e.minus === void 0 ? "\u2212" : e.minus + "", h = e.nan === void 0 ? "NaN" : e.nan + "";
  function l(f) {
    var y = (f = Mn(f)).fill, b = f.align, g = f.sign, _ = f.symbol, S = f.zero, x = f.width, C = f.comma, v = f.precision, d = f.trim, p = f.type;
    p === "n" ? (C = !0, p = "g") : tr[p] || (v === void 0 && (v = 12), d = !0, p = "g"), (S || y === "0" && b === "=") && (S = !0, y = "0", b = "=");
    var j = _ === "$" ? o : _ === "#" && /[boxX]/.test(p) ? "0" + p.toLowerCase() : "", M = _ === "$" ? i : /[%p]/.test(p) ? u : "", E = tr[p], k = /[defgprs%]/.test(p);
    function I(w) {
      var N, R, T, D = j, F = M;
      if (p === "c")
        F = E(w) + F, w = "";
      else {
        var Z = (w = +w) < 0 || 1 / w < 0;
        if (w = isNaN(w) ? h : E(Math.abs(w), v), d && (w = function(ne) {
          e:
            for (var ie, ue = ne.length, te = 1, se = -1; te < ue; ++te)
              switch (ne[te]) {
                case ".":
                  se = ie = te;
                  break;
                case "0":
                  se === 0 && (se = te), ie = te;
                  break;
                default:
                  if (!+ne[te])
                    break e;
                  se > 0 && (se = 0);
              }
          return se > 0 ? ne.slice(0, se) + ne.slice(ie + 1) : ne;
        }(w)), Z && +w == 0 && g !== "+" && (Z = !1), D = (Z ? g === "(" ? g : c : g === "-" || g === "(" ? "" : g) + D, F = (p === "s" ? ir[8 + Jr / 3] : "") + F + (Z && g === "(" ? ")" : ""), k) {
          for (N = -1, R = w.length; ++N < R; )
            if (48 > (T = w.charCodeAt(N)) || T > 57) {
              F = (T === 46 ? s + w.slice(N + 1) : w.slice(N)) + F, w = w.slice(0, N);
              break;
            }
        }
      }
      C && !S && (w = r(w, 1 / 0));
      var oe = D.length + w.length + F.length, O = oe < x ? new Array(x - oe + 1).join(y) : "";
      switch (C && S && (w = r(O + w, O.length ? x - F.length : 1 / 0), O = ""), b) {
        case "<":
          w = D + w + F + O;
          break;
        case "=":
          w = D + O + w + F;
          break;
        case "^":
          w = O.slice(0, oe = O.length >> 1) + D + w + F + O.slice(oe);
          break;
        default:
          w = O + D + w + F;
      }
      return a(w);
    }
    return v = v === void 0 ? 6 : /[gprs]/.test(p) ? Math.max(1, Math.min(21, v)) : Math.max(0, Math.min(20, v)), I.toString = () => f + "", I;
  }
  return { format: l, formatPrefix: function(f, y) {
    var b = l(((f = Mn(f)).type = "f", f)), g = 3 * Math.max(-8, Math.min(8, Math.floor(qe(y) / 3))), _ = Math.pow(10, -g), S = ir[8 + g / 3];
    return (x) => b(_ * x) + S;
  } };
}
Yn = Ko({ thousands: ",", grouping: [3], currency: ["$", ""] }), jn = Yn.format, Zr = Yn.formatPrefix;
var rt = "http://www.w3.org/1999/xhtml";
const ar = { svg: "http://www.w3.org/2000/svg", xhtml: rt, xlink: "http://www.w3.org/1999/xlink", xml: "http://www.w3.org/XML/1998/namespace", xmlns: "http://www.w3.org/2000/xmlns/" };
function En(e) {
  var n = e += "", t = n.indexOf(":");
  return t >= 0 && (n = e.slice(0, t)) !== "xmlns" && (e = e.slice(t + 1)), ar.hasOwnProperty(n) ? { space: ar[n], local: e } : e;
}
function ei(e) {
  return function() {
    var n = this.ownerDocument, t = this.namespaceURI;
    return t === rt && n.documentElement.namespaceURI === rt ? n.createElement(e) : n.createElementNS(t, e);
  };
}
function ni(e) {
  return function() {
    return this.ownerDocument.createElementNS(e.space, e.local);
  };
}
function sr(e) {
  var n = En(e);
  return (n.local ? ni : ei)(n);
}
function ti() {
}
function ot(e) {
  return e == null ? ti : function() {
    return this.querySelector(e);
  };
}
function ri(e) {
  return e == null ? [] : Array.isArray(e) ? e : Array.from(e);
}
function oi() {
  return [];
}
function Kr(e) {
  return e == null ? oi : function() {
    return this.querySelectorAll(e);
  };
}
function eo(e) {
  return function() {
    return this.matches(e);
  };
}
function ur(e) {
  return (n) => n.matches(e);
}
var ii = Array.prototype.find;
function ai() {
  return this.firstElementChild;
}
var si = Array.prototype.filter;
function ui() {
  return Array.from(this.children);
}
function cr(e) {
  return new Array(e.length);
}
function kn(e, n) {
  this.ownerDocument = e.ownerDocument, this.namespaceURI = e.namespaceURI, this._next = null, this._parent = e, this.__data__ = n;
}
function ci(e) {
  return () => e;
}
function li(e, n, t, r, o, i) {
  for (var s, a = 0, u = n.length, c = i.length; a < c; ++a)
    (s = n[a]) ? (s.__data__ = i[a], r[a] = s) : t[a] = new kn(e, i[a]);
  for (; a < u; ++a)
    (s = n[a]) && (o[a] = s);
}
function fi(e, n, t, r, o, i, s) {
  var a, u, c, h = /* @__PURE__ */ new Map(), l = n.length, f = i.length, y = new Array(l);
  for (a = 0; a < l; ++a)
    (u = n[a]) && (y[a] = c = s.call(u, u.__data__, a, n) + "", h.has(c) ? o[a] = u : h.set(c, u));
  for (a = 0; a < f; ++a)
    c = s.call(e, i[a], a, i) + "", (u = h.get(c)) ? (r[a] = u, u.__data__ = i[a], h.delete(c)) : t[a] = new kn(e, i[a]);
  for (a = 0; a < l; ++a)
    (u = n[a]) && h.get(y[a]) === u && (o[a] = u);
}
function hi(e) {
  return e.__data__;
}
function pi(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function yi(e, n) {
  return e < n ? -1 : e > n ? 1 : e >= n ? 0 : NaN;
}
function di(e) {
  return function() {
    this.removeAttribute(e);
  };
}
function mi(e) {
  return function() {
    this.removeAttributeNS(e.space, e.local);
  };
}
function gi(e, n) {
  return function() {
    this.setAttribute(e, n);
  };
}
function vi(e, n) {
  return function() {
    this.setAttributeNS(e.space, e.local, n);
  };
}
function bi(e, n) {
  return function() {
    var t = n.apply(this, arguments);
    t == null ? this.removeAttribute(e) : this.setAttribute(e, t);
  };
}
function _i(e, n) {
  return function() {
    var t = n.apply(this, arguments);
    t == null ? this.removeAttributeNS(e.space, e.local) : this.setAttributeNS(e.space, e.local, t);
  };
}
function no(e) {
  return e.ownerDocument && e.ownerDocument.defaultView || e.document && e || e.defaultView;
}
function wi(e) {
  return function() {
    this.style.removeProperty(e);
  };
}
function xi(e, n, t) {
  return function() {
    this.style.setProperty(e, n, t);
  };
}
function Si(e, n, t) {
  return function() {
    var r = n.apply(this, arguments);
    r == null ? this.style.removeProperty(e) : this.style.setProperty(e, r, t);
  };
}
function Le(e, n) {
  return e.style.getPropertyValue(n) || no(e).getComputedStyle(e, null).getPropertyValue(n);
}
function Oi(e) {
  return function() {
    delete this[e];
  };
}
function Mi(e, n) {
  return function() {
    this[e] = n;
  };
}
function ji(e, n) {
  return function() {
    var t = n.apply(this, arguments);
    t == null ? delete this[e] : this[e] = t;
  };
}
function to(e) {
  return e.trim().split(/^|\s+/);
}
function Mt(e) {
  return e.classList || new ro(e);
}
function ro(e) {
  this._node = e, this._names = to(e.getAttribute("class") || "");
}
function oo(e, n) {
  for (var t = Mt(e), r = -1, o = n.length; ++r < o; )
    t.add(n[r]);
}
function io(e, n) {
  for (var t = Mt(e), r = -1, o = n.length; ++r < o; )
    t.remove(n[r]);
}
function Ei(e) {
  return function() {
    oo(this, e);
  };
}
function ki(e) {
  return function() {
    io(this, e);
  };
}
function Ai(e, n) {
  return function() {
    (n.apply(this, arguments) ? oo : io)(this, e);
  };
}
function Ni() {
  this.textContent = "";
}
function $i(e) {
  return function() {
    this.textContent = e;
  };
}
function Ti(e) {
  return function() {
    var n = e.apply(this, arguments);
    this.textContent = n != null ? n : "";
  };
}
function Ci() {
  this.innerHTML = "";
}
function Ii(e) {
  return function() {
    this.innerHTML = e;
  };
}
function Pi(e) {
  return function() {
    var n = e.apply(this, arguments);
    this.innerHTML = n != null ? n : "";
  };
}
function Ri() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function Fi() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function Vi() {
  return null;
}
function Di() {
  var e = this.parentNode;
  e && e.removeChild(this);
}
function qi() {
  var e = this.cloneNode(!1), n = this.parentNode;
  return n ? n.insertBefore(e, this.nextSibling) : e;
}
function Li() {
  var e = this.cloneNode(!0), n = this.parentNode;
  return n ? n.insertBefore(e, this.nextSibling) : e;
}
function zi(e) {
  return e.trim().split(/^|\s+/).map((n) => {
    var t = "", r = n.indexOf(".");
    return r >= 0 && (t = n.slice(r + 1), n = n.slice(0, r)), { type: n, name: t };
  });
}
function Wi(e) {
  return function() {
    var n = this.__on;
    if (n) {
      for (var t, r = 0, o = -1, i = n.length; r < i; ++r)
        t = n[r], e.type && t.type !== e.type || t.name !== e.name ? n[++o] = t : this.removeEventListener(t.type, t.listener, t.options);
      ++o ? n.length = o : delete this.__on;
    }
  };
}
function Bi(e, n, t) {
  return function() {
    var r, o = this.__on, i = function(u) {
      return function(c) {
        u.call(this, c, this.__data__);
      };
    }(n);
    if (o) {
      for (var s = 0, a = o.length; s < a; ++s)
        if ((r = o[s]).type === e.type && r.name === e.name)
          return this.removeEventListener(r.type, r.listener, r.options), this.addEventListener(r.type, r.listener = i, r.options = t), void (r.value = n);
    }
    this.addEventListener(e.type, i, t), r = { type: e.type, name: e.name, value: n, listener: i, options: t }, o ? o.push(r) : this.__on = [r];
  };
}
function ao(e, n, t) {
  var r = no(e), o = r.CustomEvent;
  typeof o == "function" ? o = new o(n, t) : (o = r.document.createEvent("Event"), t ? (o.initEvent(n, t.bubbles, t.cancelable), o.detail = t.detail) : o.initEvent(n, !1, !1)), e.dispatchEvent(o);
}
function Ui(e, n) {
  return function() {
    return ao(this, e, n);
  };
}
function Hi(e, n) {
  return function() {
    return ao(this, e, n.apply(this, arguments));
  };
}
kn.prototype = { constructor: kn, appendChild: function(e) {
  return this._parent.insertBefore(e, this._next);
}, insertBefore: function(e, n) {
  return this._parent.insertBefore(e, n);
}, querySelector: function(e) {
  return this._parent.querySelector(e);
}, querySelectorAll: function(e) {
  return this._parent.querySelectorAll(e);
} }, ro.prototype = { add: function(e) {
  this._names.indexOf(e) < 0 && (this._names.push(e), this._node.setAttribute("class", this._names.join(" ")));
}, remove: function(e) {
  var n = this._names.indexOf(e);
  n >= 0 && (this._names.splice(n, 1), this._node.setAttribute("class", this._names.join(" ")));
}, contains: function(e) {
  return this._names.indexOf(e) >= 0;
} };
var so = [null];
function fe(e, n) {
  this._groups = e, this._parents = n;
}
function He() {
  return new fe([[document.documentElement]], so);
}
function uo(e) {
  return typeof e == "string" ? new fe([[document.querySelector(e)]], [document.documentElement]) : new fe([[e]], so);
}
function it(e, n) {
  return e == null || n == null ? NaN : e < n ? -1 : e > n ? 1 : e >= n ? 0 : NaN;
}
function co(e) {
  let n = e, t = e, r = e;
  function o(i, s, a = 0, u = i.length) {
    if (a < u) {
      if (t(s, s) !== 0)
        return u;
      do {
        const c = a + u >>> 1;
        r(i[c], s) < 0 ? a = c + 1 : u = c;
      } while (a < u);
    }
    return a;
  }
  return e.length !== 2 && (n = (i, s) => e(i) - s, t = it, r = (i, s) => it(e(i), s)), { left: o, center: function(i, s, a = 0, u = i.length) {
    const c = o(i, s, a, u - 1);
    return c > a && n(i[c - 1], s) > -n(i[c], s) ? c - 1 : c;
  }, right: function(i, s, a = 0, u = i.length) {
    if (a < u) {
      if (t(s, s) !== 0)
        return u;
      do {
        const c = a + u >>> 1;
        r(i[c], s) <= 0 ? a = c + 1 : u = c;
      } while (a < u);
    }
    return a;
  } };
}
fe.prototype = He.prototype = { constructor: fe, select: function(e) {
  typeof e != "function" && (e = ot(e));
  for (var n = this._groups, t = n.length, r = new Array(t), o = 0; o < t; ++o)
    for (var i, s, a = n[o], u = a.length, c = r[o] = new Array(u), h = 0; h < u; ++h)
      (i = a[h]) && (s = e.call(i, i.__data__, h, a)) && ("__data__" in i && (s.__data__ = i.__data__), c[h] = s);
  return new fe(r, this._parents);
}, selectAll: function(e) {
  e = typeof e == "function" ? function(h) {
    return function() {
      return ri(h.apply(this, arguments));
    };
  }(e) : Kr(e);
  for (var n = this._groups, t = n.length, r = [], o = [], i = 0; i < t; ++i)
    for (var s, a = n[i], u = a.length, c = 0; c < u; ++c)
      (s = a[c]) && (r.push(e.call(s, s.__data__, c, a)), o.push(s));
  return new fe(r, o);
}, selectChild: function(e) {
  return this.select(e == null ? ai : function(n) {
    return function() {
      return ii.call(this.children, n);
    };
  }(typeof e == "function" ? e : ur(e)));
}, selectChildren: function(e) {
  return this.selectAll(e == null ? ui : function(n) {
    return function() {
      return si.call(this.children, n);
    };
  }(typeof e == "function" ? e : ur(e)));
}, filter: function(e) {
  typeof e != "function" && (e = eo(e));
  for (var n = this._groups, t = n.length, r = new Array(t), o = 0; o < t; ++o)
    for (var i, s = n[o], a = s.length, u = r[o] = [], c = 0; c < a; ++c)
      (i = s[c]) && e.call(i, i.__data__, c, s) && u.push(i);
  return new fe(r, this._parents);
}, data: function(e, n) {
  if (!arguments.length)
    return Array.from(this, hi);
  var t = n ? fi : li, r = this._parents, o = this._groups;
  typeof e != "function" && (e = ci(e));
  for (var i = o.length, s = new Array(i), a = new Array(i), u = new Array(i), c = 0; c < i; ++c) {
    var h = r[c], l = o[c], f = l.length, y = pi(e.call(h, h && h.__data__, c, r)), b = y.length, g = a[c] = new Array(b), _ = s[c] = new Array(b), S = u[c] = new Array(f);
    t(h, l, g, _, S, y, n);
    for (var x, C, v = 0, d = 0; v < b; ++v)
      if (x = g[v]) {
        for (v >= d && (d = v + 1); !(C = _[d]) && ++d < b; )
          ;
        x._next = C || null;
      }
  }
  return (s = new fe(s, r))._enter = a, s._exit = u, s;
}, enter: function() {
  return new fe(this._enter || this._groups.map(cr), this._parents);
}, exit: function() {
  return new fe(this._exit || this._groups.map(cr), this._parents);
}, join: function(e, n, t) {
  var r = this.enter(), o = this, i = this.exit();
  return typeof e == "function" ? (r = e(r)) && (r = r.selection()) : r = r.append(e + ""), n != null && (o = n(o)) && (o = o.selection()), t == null ? i.remove() : t(i), r && o ? r.merge(o).order() : o;
}, merge: function(e) {
  for (var n = e.selection ? e.selection() : e, t = this._groups, r = n._groups, o = t.length, i = r.length, s = Math.min(o, i), a = new Array(o), u = 0; u < s; ++u)
    for (var c, h = t[u], l = r[u], f = h.length, y = a[u] = new Array(f), b = 0; b < f; ++b)
      (c = h[b] || l[b]) && (y[b] = c);
  for (; u < o; ++u)
    a[u] = t[u];
  return new fe(a, this._parents);
}, selection: function() {
  return this;
}, order: function() {
  for (var e = this._groups, n = -1, t = e.length; ++n < t; )
    for (var r, o = e[n], i = o.length - 1, s = o[i]; --i >= 0; )
      (r = o[i]) && (s && 4 ^ r.compareDocumentPosition(s) && s.parentNode.insertBefore(r, s), s = r);
  return this;
}, sort: function(e) {
  function n(l, f) {
    return l && f ? e(l.__data__, f.__data__) : !l - !f;
  }
  e || (e = yi);
  for (var t = this._groups, r = t.length, o = new Array(r), i = 0; i < r; ++i) {
    for (var s, a = t[i], u = a.length, c = o[i] = new Array(u), h = 0; h < u; ++h)
      (s = a[h]) && (c[h] = s);
    c.sort(n);
  }
  return new fe(o, this._parents).order();
}, call: function() {
  var e = arguments[0];
  return arguments[0] = this, e.apply(null, arguments), this;
}, nodes: function() {
  return Array.from(this);
}, node: function() {
  for (var e = this._groups, n = 0, t = e.length; n < t; ++n)
    for (var r = e[n], o = 0, i = r.length; o < i; ++o) {
      var s = r[o];
      if (s)
        return s;
    }
  return null;
}, size: function() {
  let e = 0;
  for (const n of this)
    ++e;
  return e;
}, empty: function() {
  return !this.node();
}, each: function(e) {
  for (var n = this._groups, t = 0, r = n.length; t < r; ++t)
    for (var o, i = n[t], s = 0, a = i.length; s < a; ++s)
      (o = i[s]) && e.call(o, o.__data__, s, i);
  return this;
}, attr: function(e, n) {
  var t = En(e);
  if (arguments.length < 2) {
    var r = this.node();
    return t.local ? r.getAttributeNS(t.space, t.local) : r.getAttribute(t);
  }
  return this.each((n == null ? t.local ? mi : di : typeof n == "function" ? t.local ? _i : bi : t.local ? vi : gi)(t, n));
}, style: function(e, n, t) {
  return arguments.length > 1 ? this.each((n == null ? wi : typeof n == "function" ? Si : xi)(e, n, t != null ? t : "")) : Le(this.node(), e);
}, property: function(e, n) {
  return arguments.length > 1 ? this.each((n == null ? Oi : typeof n == "function" ? ji : Mi)(e, n)) : this.node()[e];
}, classed: function(e, n) {
  var t = to(e + "");
  if (arguments.length < 2) {
    for (var r = Mt(this.node()), o = -1, i = t.length; ++o < i; )
      if (!r.contains(t[o]))
        return !1;
    return !0;
  }
  return this.each((typeof n == "function" ? Ai : n ? Ei : ki)(t, n));
}, text: function(e) {
  return arguments.length ? this.each(e == null ? Ni : (typeof e == "function" ? Ti : $i)(e)) : this.node().textContent;
}, html: function(e) {
  return arguments.length ? this.each(e == null ? Ci : (typeof e == "function" ? Pi : Ii)(e)) : this.node().innerHTML;
}, raise: function() {
  return this.each(Ri);
}, lower: function() {
  return this.each(Fi);
}, append: function(e) {
  var n = typeof e == "function" ? e : sr(e);
  return this.select(function() {
    return this.appendChild(n.apply(this, arguments));
  });
}, insert: function(e, n) {
  var t = typeof e == "function" ? e : sr(e), r = n == null ? Vi : typeof n == "function" ? n : ot(n);
  return this.select(function() {
    return this.insertBefore(t.apply(this, arguments), r.apply(this, arguments) || null);
  });
}, remove: function() {
  return this.each(Di);
}, clone: function(e) {
  return this.select(e ? Li : qi);
}, datum: function(e) {
  return arguments.length ? this.property("__data__", e) : this.node().__data__;
}, on: function(e, n, t) {
  var r, o, i = zi(e + ""), s = i.length;
  if (!(arguments.length < 2)) {
    for (a = n ? Bi : Wi, r = 0; r < s; ++r)
      this.each(a(i[r], n, t));
    return this;
  }
  var a = this.node().__on;
  if (a) {
    for (var u, c = 0, h = a.length; c < h; ++c)
      for (r = 0, u = a[c]; r < s; ++r)
        if ((o = i[r]).type === u.type && o.name === u.name)
          return u.value;
  }
}, dispatch: function(e, n) {
  return this.each((typeof n == "function" ? Hi : Ui)(e, n));
}, [Symbol.iterator]: function* () {
  for (var e = this._groups, n = 0, t = e.length; n < t; ++n)
    for (var r, o = e[n], i = 0, s = o.length; i < s; ++i)
      (r = o[i]) && (yield r);
} };
const Yi = co(it).right;
co(function(e) {
  return e === null ? NaN : +e;
}).center;
const lo = Yi;
var at = Math.sqrt(50), st = Math.sqrt(10), ut = Math.sqrt(2);
function lr(e, n, t) {
  var r = (n - e) / Math.max(0, t), o = Math.floor(Math.log(r) / Math.LN10), i = r / Math.pow(10, o);
  return o >= 0 ? (i >= at ? 10 : i >= st ? 5 : i >= ut ? 2 : 1) * Math.pow(10, o) : -Math.pow(10, -o) / (i >= at ? 10 : i >= st ? 5 : i >= ut ? 2 : 1);
}
function fo(e, n) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(n).domain(e);
  }
  return this;
}
function Xn(e, n, t) {
  e.prototype = n.prototype = t, t.constructor = e;
}
function fr(e, n) {
  var t = Object.create(e.prototype);
  for (var r in n)
    t[r] = n[r];
  return t;
}
function tn() {
}
var hn = 1 / 0.7, Ue = "\\s*([+-]?\\d+)\\s*", an = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", me = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Xi = /^#([0-9a-f]{3,8})$/, Qi = new RegExp(`^rgb\\(${Ue},${Ue},${Ue}\\)$`), Gi = new RegExp(`^rgb\\(${me},${me},${me}\\)$`), Ji = new RegExp(`^rgba\\(${Ue},${Ue},${Ue},${an}\\)$`), Zi = new RegExp(`^rgba\\(${me},${me},${me},${an}\\)$`), Ki = new RegExp(`^hsl\\(${an},${me},${me}\\)$`), ea = new RegExp(`^hsla\\(${an},${me},${me},${an}\\)$`), hr = { aliceblue: 15792383, antiquewhite: 16444375, aqua: 65535, aquamarine: 8388564, azure: 15794175, beige: 16119260, bisque: 16770244, black: 0, blanchedalmond: 16772045, blue: 255, blueviolet: 9055202, brown: 10824234, burlywood: 14596231, cadetblue: 6266528, chartreuse: 8388352, chocolate: 13789470, coral: 16744272, cornflowerblue: 6591981, cornsilk: 16775388, crimson: 14423100, cyan: 65535, darkblue: 139, darkcyan: 35723, darkgoldenrod: 12092939, darkgray: 11119017, darkgreen: 25600, darkgrey: 11119017, darkkhaki: 12433259, darkmagenta: 9109643, darkolivegreen: 5597999, darkorange: 16747520, darkorchid: 10040012, darkred: 9109504, darksalmon: 15308410, darkseagreen: 9419919, darkslateblue: 4734347, darkslategray: 3100495, darkslategrey: 3100495, darkturquoise: 52945, darkviolet: 9699539, deeppink: 16716947, deepskyblue: 49151, dimgray: 6908265, dimgrey: 6908265, dodgerblue: 2003199, firebrick: 11674146, floralwhite: 16775920, forestgreen: 2263842, fuchsia: 16711935, gainsboro: 14474460, ghostwhite: 16316671, gold: 16766720, goldenrod: 14329120, gray: 8421504, green: 32768, greenyellow: 11403055, grey: 8421504, honeydew: 15794160, hotpink: 16738740, indianred: 13458524, indigo: 4915330, ivory: 16777200, khaki: 15787660, lavender: 15132410, lavenderblush: 16773365, lawngreen: 8190976, lemonchiffon: 16775885, lightblue: 11393254, lightcoral: 15761536, lightcyan: 14745599, lightgoldenrodyellow: 16448210, lightgray: 13882323, lightgreen: 9498256, lightgrey: 13882323, lightpink: 16758465, lightsalmon: 16752762, lightseagreen: 2142890, lightskyblue: 8900346, lightslategray: 7833753, lightslategrey: 7833753, lightsteelblue: 11584734, lightyellow: 16777184, lime: 65280, limegreen: 3329330, linen: 16445670, magenta: 16711935, maroon: 8388608, mediumaquamarine: 6737322, mediumblue: 205, mediumorchid: 12211667, mediumpurple: 9662683, mediumseagreen: 3978097, mediumslateblue: 8087790, mediumspringgreen: 64154, mediumturquoise: 4772300, mediumvioletred: 13047173, midnightblue: 1644912, mintcream: 16121850, mistyrose: 16770273, moccasin: 16770229, navajowhite: 16768685, navy: 128, oldlace: 16643558, olive: 8421376, olivedrab: 7048739, orange: 16753920, orangered: 16729344, orchid: 14315734, palegoldenrod: 15657130, palegreen: 10025880, paleturquoise: 11529966, palevioletred: 14381203, papayawhip: 16773077, peachpuff: 16767673, peru: 13468991, pink: 16761035, plum: 14524637, powderblue: 11591910, purple: 8388736, rebeccapurple: 6697881, red: 16711680, rosybrown: 12357519, royalblue: 4286945, saddlebrown: 9127187, salmon: 16416882, sandybrown: 16032864, seagreen: 3050327, seashell: 16774638, sienna: 10506797, silver: 12632256, skyblue: 8900331, slateblue: 6970061, slategray: 7372944, slategrey: 7372944, snow: 16775930, springgreen: 65407, steelblue: 4620980, tan: 13808780, teal: 32896, thistle: 14204888, tomato: 16737095, turquoise: 4251856, violet: 15631086, wheat: 16113331, white: 16777215, whitesmoke: 16119285, yellow: 16776960, yellowgreen: 10145074 };
function pr() {
  return this.rgb().formatHex();
}
function yr() {
  return this.rgb().formatRgb();
}
function Ne(e) {
  var n, t;
  return e = (e + "").trim().toLowerCase(), (n = Xi.exec(e)) ? (t = n[1].length, n = parseInt(n[1], 16), t === 6 ? dr(n) : t === 3 ? new le(n >> 8 & 15 | n >> 4 & 240, n >> 4 & 15 | 240 & n, (15 & n) << 4 | 15 & n, 1) : t === 8 ? pn(n >> 24 & 255, n >> 16 & 255, n >> 8 & 255, (255 & n) / 255) : t === 4 ? pn(n >> 12 & 15 | n >> 8 & 240, n >> 8 & 15 | n >> 4 & 240, n >> 4 & 15 | 240 & n, ((15 & n) << 4 | 15 & n) / 255) : null) : (n = Qi.exec(e)) ? new le(n[1], n[2], n[3], 1) : (n = Gi.exec(e)) ? new le(255 * n[1] / 100, 255 * n[2] / 100, 255 * n[3] / 100, 1) : (n = Ji.exec(e)) ? pn(n[1], n[2], n[3], n[4]) : (n = Zi.exec(e)) ? pn(255 * n[1] / 100, 255 * n[2] / 100, 255 * n[3] / 100, n[4]) : (n = Ki.exec(e)) ? vr(n[1], n[2] / 100, n[3] / 100, 1) : (n = ea.exec(e)) ? vr(n[1], n[2] / 100, n[3] / 100, n[4]) : hr.hasOwnProperty(e) ? dr(hr[e]) : e === "transparent" ? new le(NaN, NaN, NaN, 0) : null;
}
function dr(e) {
  return new le(e >> 16 & 255, e >> 8 & 255, 255 & e, 1);
}
function pn(e, n, t, r) {
  return r <= 0 && (e = n = t = NaN), new le(e, n, t, r);
}
function na(e) {
  return e instanceof tn || (e = Ne(e)), e ? new le((e = e.rgb()).r, e.g, e.b, e.opacity) : new le();
}
function sn(e, n, t, r) {
  return arguments.length === 1 ? na(e) : new le(e, n, t, r != null ? r : 1);
}
function le(e, n, t, r) {
  this.r = +e, this.g = +n, this.b = +t, this.opacity = +r;
}
function mr() {
  return `#${Ee(this.r)}${Ee(this.g)}${Ee(this.b)}`;
}
function gr() {
  const e = bn(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${ke(this.r)}, ${ke(this.g)}, ${ke(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function bn(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function ke(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function Ee(e) {
  return ((e = ke(e)) < 16 ? "0" : "") + e.toString(16);
}
function vr(e, n, t, r) {
  return r <= 0 ? e = n = t = NaN : t <= 0 || t >= 1 ? e = n = NaN : n <= 0 && (e = NaN), new ye(e, n, t, r);
}
function ho(e) {
  if (e instanceof ye)
    return new ye(e.h, e.s, e.l, e.opacity);
  if (e instanceof tn || (e = Ne(e)), !e)
    return new ye();
  if (e instanceof ye)
    return e;
  var n = (e = e.rgb()).r / 255, t = e.g / 255, r = e.b / 255, o = Math.min(n, t, r), i = Math.max(n, t, r), s = NaN, a = i - o, u = (i + o) / 2;
  return a ? (s = n === i ? (t - r) / a + 6 * (t < r) : t === i ? (r - n) / a + 2 : (n - t) / a + 4, a /= u < 0.5 ? i + o : 2 - i - o, s *= 60) : a = u > 0 && u < 1 ? 0 : s, new ye(s, a, u, e.opacity);
}
function ct(e, n, t, r) {
  return arguments.length === 1 ? ho(e) : new ye(e, n, t, r != null ? r : 1);
}
function ye(e, n, t, r) {
  this.h = +e, this.s = +n, this.l = +t, this.opacity = +r;
}
function br(e) {
  return (e = (e || 0) % 360) < 0 ? e + 360 : e;
}
function yn(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function Qn(e, n, t) {
  return 255 * (e < 60 ? n + (t - n) * e / 60 : e < 180 ? t : e < 240 ? n + (t - n) * (240 - e) / 60 : n);
}
Xn(tn, Ne, { copy(e) {
  return Object.assign(new this.constructor(), this, e);
}, displayable() {
  return this.rgb().displayable();
}, hex: pr, formatHex: pr, formatHex8: function() {
  return this.rgb().formatHex8();
}, formatHsl: function() {
  return ho(this).formatHsl();
}, formatRgb: yr, toString: yr }), Xn(le, sn, fr(tn, { brighter(e) {
  return e = e == null ? hn : Math.pow(hn, e), new le(this.r * e, this.g * e, this.b * e, this.opacity);
}, darker(e) {
  return e = e == null ? 0.7 : Math.pow(0.7, e), new le(this.r * e, this.g * e, this.b * e, this.opacity);
}, rgb() {
  return this;
}, clamp() {
  return new le(ke(this.r), ke(this.g), ke(this.b), bn(this.opacity));
}, displayable() {
  return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
}, hex: mr, formatHex: mr, formatHex8: function() {
  return `#${Ee(this.r)}${Ee(this.g)}${Ee(this.b)}${Ee(255 * (isNaN(this.opacity) ? 1 : this.opacity))}`;
}, formatRgb: gr, toString: gr })), Xn(ye, ct, fr(tn, { brighter(e) {
  return e = e == null ? hn : Math.pow(hn, e), new ye(this.h, this.s, this.l * e, this.opacity);
}, darker(e) {
  return e = e == null ? 0.7 : Math.pow(0.7, e), new ye(this.h, this.s, this.l * e, this.opacity);
}, rgb() {
  var e = this.h % 360 + 360 * (this.h < 0), n = isNaN(e) || isNaN(this.s) ? 0 : this.s, t = this.l, r = t + (t < 0.5 ? t : 1 - t) * n, o = 2 * t - r;
  return new le(Qn(e >= 240 ? e - 240 : e + 120, o, r), Qn(e, o, r), Qn(e < 120 ? e + 240 : e - 120, o, r), this.opacity);
}, clamp() {
  return new ye(br(this.h), yn(this.s), yn(this.l), bn(this.opacity));
}, displayable() {
  return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
}, formatHsl() {
  const e = bn(this.opacity);
  return `${e === 1 ? "hsl(" : "hsla("}${br(this.h)}, ${100 * yn(this.s)}%, ${100 * yn(this.l)}%${e === 1 ? ")" : `, ${e})`}`;
} }));
const Fn = (e) => () => e;
function po(e, n) {
  return (t) => e + t * n;
}
function ta(e) {
  return (e = +e) == 1 ? rn : (n, t) => t - n ? function(r, o, i) {
    return r = Math.pow(r, i), o = Math.pow(o, i) - r, i = 1 / i, (s) => Math.pow(r + s * o, i);
  }(n, t, e) : Fn(isNaN(n) ? t : n);
}
function rn(e, n) {
  var t = n - e;
  return t ? po(e, t) : Fn(isNaN(e) ? n : e);
}
const An = function e(n) {
  var t = ta(n);
  function r(o, i) {
    var s = t((o = sn(o)).r, (i = sn(i)).r), a = t(o.g, i.g), u = t(o.b, i.b), c = rn(o.opacity, i.opacity);
    return (h) => (o.r = s(h), o.g = a(h), o.b = u(h), o.opacity = c(h), o + "");
  }
  return r.gamma = e, r;
}(1);
function ra(e, n) {
  n || (n = []);
  var t, r = e ? Math.min(n.length, e.length) : 0, o = n.slice();
  return (i) => {
    for (t = 0; t < r; ++t)
      o[t] = e[t] * (1 - i) + n[t] * i;
    return o;
  };
}
function oa(e, n) {
  var t, r = n ? n.length : 0, o = e ? Math.min(r, e.length) : 0, i = new Array(o), s = new Array(r);
  for (t = 0; t < o; ++t)
    i[t] = jt(e[t], n[t]);
  for (; t < r; ++t)
    s[t] = n[t];
  return (a) => {
    for (t = 0; t < o; ++t)
      s[t] = i[t](a);
    return s;
  };
}
function ia(e, n) {
  var t = new Date();
  return e = +e, n = +n, (r) => (t.setTime(e * (1 - r) + n * r), t);
}
function pe(e, n) {
  return e = +e, n = +n, (t) => e * (1 - t) + n * t;
}
function aa(e, n) {
  var t, r = {}, o = {};
  for (t in e !== null && typeof e == "object" || (e = {}), n !== null && typeof n == "object" || (n = {}), n)
    t in e ? r[t] = jt(e[t], n[t]) : o[t] = n[t];
  return (i) => {
    for (t in r)
      o[t] = r[t](i);
    return o;
  };
}
var lt = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Gn = new RegExp(lt.source, "g");
function yo(e, n) {
  var t, r, o, i = lt.lastIndex = Gn.lastIndex = 0, s = -1, a = [], u = [];
  for (e += "", n += ""; (t = lt.exec(e)) && (r = Gn.exec(n)); )
    (o = r.index) > i && (o = n.slice(i, o), a[s] ? a[s] += o : a[++s] = o), (t = t[0]) === (r = r[0]) ? a[s] ? a[s] += r : a[++s] = r : (a[++s] = null, u.push({ i: s, x: pe(t, r) })), i = Gn.lastIndex;
  return i < n.length && (o = n.slice(i), a[s] ? a[s] += o : a[++s] = o), a.length < 2 ? u[0] ? function(c) {
    return (h) => c(h) + "";
  }(u[0].x) : function(c) {
    return () => c;
  }(n) : (n = u.length, (c) => {
    for (var h, l = 0; l < n; ++l)
      a[(h = u[l]).i] = h.x(c);
    return a.join("");
  });
}
function jt(e, n) {
  var t, r = typeof n;
  return n == null || r === "boolean" ? Fn(n) : (r === "number" ? pe : r === "string" ? (t = Ne(n)) ? (n = t, An) : yo : n instanceof Ne ? An : n instanceof Date ? ia : function(o) {
    return ArrayBuffer.isView(o) && !(o instanceof DataView);
  }(n) ? ra : Array.isArray(n) ? oa : typeof n.valueOf != "function" && typeof n.toString != "function" || isNaN(n) ? aa : pe)(e, n);
}
function sa(e, n) {
  return e = +e, n = +n, (t) => Math.round(e * (1 - t) + n * t);
}
var dn, _r = 180 / Math.PI, ft = { translateX: 0, translateY: 0, rotate: 0, skewX: 0, scaleX: 1, scaleY: 1 };
function mo(e, n, t, r, o, i) {
  var s, a, u;
  return (s = Math.sqrt(e * e + n * n)) && (e /= s, n /= s), (u = e * t + n * r) && (t -= e * u, r -= n * u), (a = Math.sqrt(t * t + r * r)) && (t /= a, r /= a, u /= a), e * r < n * t && (e = -e, n = -n, u = -u, s = -s), { translateX: o, translateY: i, rotate: Math.atan2(n, e) * _r, skewX: Math.atan(u) * _r, scaleX: s, scaleY: a };
}
function go(e, n, t, r) {
  function o(i) {
    return i.length ? i.pop() + " " : "";
  }
  return (i, s) => {
    var a = [], u = [];
    return i = e(i), s = e(s), function(c, h, l, f, y, b) {
      if (c !== l || h !== f) {
        var g = y.push("translate(", null, n, null, t);
        b.push({ i: g - 4, x: pe(c, l) }, { i: g - 2, x: pe(h, f) });
      } else
        (l || f) && y.push("translate(" + l + n + f + t);
    }(i.translateX, i.translateY, s.translateX, s.translateY, a, u), function(c, h, l, f) {
      c !== h ? (c - h > 180 ? h += 360 : h - c > 180 && (c += 360), f.push({ i: l.push(o(l) + "rotate(", null, r) - 2, x: pe(c, h) })) : h && l.push(o(l) + "rotate(" + h + r);
    }(i.rotate, s.rotate, a, u), function(c, h, l, f) {
      c !== h ? f.push({ i: l.push(o(l) + "skewX(", null, r) - 2, x: pe(c, h) }) : h && l.push(o(l) + "skewX(" + h + r);
    }(i.skewX, s.skewX, a, u), function(c, h, l, f, y, b) {
      if (c !== l || h !== f) {
        var g = y.push(o(y) + "scale(", null, ",", null, ")");
        b.push({ i: g - 4, x: pe(c, l) }, { i: g - 2, x: pe(h, f) });
      } else
        l === 1 && f === 1 || y.push(o(y) + "scale(" + l + "," + f + ")");
    }(i.scaleX, i.scaleY, s.scaleX, s.scaleY, a, u), i = s = null, (c) => {
      for (var h, l = -1, f = u.length; ++l < f; )
        a[(h = u[l]).i] = h.x(c);
      return a.join("");
    };
  };
}
var ua = go(function(e) {
  const n = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(e + "");
  return n.isIdentity ? ft : mo(n.a, n.b, n.c, n.d, n.e, n.f);
}, "px, ", "px)", "deg)"), ca = go(function(e) {
  return e == null ? ft : (dn || (dn = document.createElementNS("http://www.w3.org/2000/svg", "g")), dn.setAttribute("transform", e), (e = dn.transform.baseVal.consolidate()) ? mo((e = e.matrix).a, e.b, e.c, e.d, e.e, e.f) : ft);
}, ", ", ")", ")");
const la = function(e) {
  return (n, t) => {
    var r = e((n = ct(n)).h, (t = ct(t)).h), o = rn(n.s, t.s), i = rn(n.l, t.l), s = rn(n.opacity, t.opacity);
    return (a) => (n.h = r(a), n.s = o(a), n.l = i(a), n.opacity = s(a), n + "");
  };
}(function(e, n) {
  var t = n - e;
  return t ? po(e, t > 180 || t < -180 ? t - 360 * Math.round(t / 360) : t) : Fn(isNaN(e) ? n : e);
});
function fa(e) {
  return +e;
}
var wr = [0, 1];
function ze(e) {
  return e;
}
function ht(e, n) {
  return (n -= e = +e) ? (t) => (t - e) / n : function(t) {
    return () => t;
  }(isNaN(n) ? NaN : 0.5);
}
function ha(e, n, t) {
  var r = e[0], o = e[1], i = n[0], s = n[1];
  return o < r ? (r = ht(o, r), i = t(s, i)) : (r = ht(r, o), i = t(i, s)), (a) => i(r(a));
}
function pa(e, n, t) {
  var r = Math.min(e.length, n.length) - 1, o = new Array(r), i = new Array(r), s = -1;
  for (e[r] < e[0] && (e = e.slice().reverse(), n = n.slice().reverse()); ++s < r; )
    o[s] = ht(e[s], e[s + 1]), i[s] = t(n[s], n[s + 1]);
  return (a) => {
    var u = lo(e, a, 1, r) - 1;
    return i[u](o[u](a));
  };
}
function ya(e, n) {
  return n.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function da() {
  var e, n, t, r, o, i, s = wr, a = wr, u = jt, c = ze;
  function h() {
    var f, y, b, g = Math.min(s.length, a.length);
    return c !== ze && (f = s[0], y = s[g - 1], f > y && (b = f, f = y, y = b), c = (_) => Math.max(f, Math.min(y, _))), r = g > 2 ? pa : ha, o = i = null, l;
  }
  function l(f) {
    return f == null || isNaN(f = +f) ? t : (o || (o = r(s.map(e), a, u)))(e(c(f)));
  }
  return l.invert = (f) => c(n((i || (i = r(a, s.map(e), pe)))(f))), l.domain = function(f) {
    return arguments.length ? (s = Array.from(f, fa), h()) : s.slice();
  }, l.range = function(f) {
    return arguments.length ? (a = Array.from(f), h()) : a.slice();
  }, l.rangeRound = (f) => (a = Array.from(f), u = sa, h()), l.clamp = function(f) {
    return arguments.length ? (c = !!f || ze, h()) : c !== ze;
  }, l.interpolate = function(f) {
    return arguments.length ? (u = f, h()) : u;
  }, l.unknown = function(f) {
    return arguments.length ? (t = f, l) : t;
  }, (f, y) => (e = f, n = y, h());
}
function ma() {
  return da()(ze, ze);
}
function ga(e, n, t, r) {
  var o, i = function(a, u, c) {
    var h = Math.abs(u - a) / Math.max(0, c), l = Math.pow(10, Math.floor(Math.log(h) / Math.LN10)), f = h / l;
    return f >= at ? l *= 10 : f >= st ? l *= 5 : f >= ut && (l *= 2), u < a ? -l : l;
  }(e, n, t);
  switch ((r = Mn(r != null ? r : ",f")).type) {
    case "s":
      var s = Math.max(Math.abs(e), Math.abs(n));
      return r.precision != null || isNaN(o = function(a, u) {
        return Math.max(0, 3 * Math.max(-8, Math.min(8, Math.floor(qe(u) / 3))) - qe(Math.abs(a)));
      }(i, s)) || (r.precision = o), Zr(r, s);
    case "":
    case "e":
    case "g":
    case "p":
    case "r":
      r.precision != null || isNaN(o = function(a, u) {
        return a = Math.abs(a), u = Math.abs(u) - a, Math.max(0, qe(u) - qe(a)) + 1;
      }(i, Math.max(Math.abs(e), Math.abs(n)))) || (r.precision = o - (r.type === "e"));
      break;
    case "f":
    case "%":
      r.precision != null || isNaN(o = function(a) {
        return Math.max(0, -qe(Math.abs(a)));
      }(i)) || (r.precision = o - 2 * (r.type === "%"));
  }
  return jn(r);
}
function vo(e) {
  var n = e.domain;
  return e.ticks = (t) => {
    var r = n();
    return function(o, i, s) {
      var a, u, c, h, l = -1;
      if (s = +s, (o = +o) == (i = +i) && s > 0)
        return [o];
      if ((a = i < o) && (u = o, o = i, i = u), (h = lr(o, i, s)) === 0 || !isFinite(h))
        return [];
      if (h > 0) {
        let f = Math.round(o / h), y = Math.round(i / h);
        for (f * h < o && ++f, y * h > i && --y, c = new Array(u = y - f + 1); ++l < u; )
          c[l] = (f + l) * h;
      } else {
        h = -h;
        let f = Math.round(o * h), y = Math.round(i * h);
        for (f / h < o && ++f, y / h > i && --y, c = new Array(u = y - f + 1); ++l < u; )
          c[l] = (f + l) / h;
      }
      return a && c.reverse(), c;
    }(r[0], r[r.length - 1], t != null ? t : 10);
  }, e.tickFormat = (t, r) => {
    var o = n();
    return ga(o[0], o[o.length - 1], t != null ? t : 10, r);
  }, e.nice = (t) => {
    t == null && (t = 10);
    var r, o, i = n(), s = 0, a = i.length - 1, u = i[s], c = i[a], h = 10;
    for (c < u && (o = u, u = c, c = o, o = s, s = a, a = o); h-- > 0; ) {
      if ((o = lr(u, c, t)) === r)
        return i[s] = u, i[a] = c, n(i);
      if (o > 0)
        u = Math.floor(u / o) * o, c = Math.ceil(c / o) * o;
      else {
        if (!(o < 0))
          break;
        u = Math.ceil(u * o) / o, c = Math.floor(c * o) / o;
      }
      r = o;
    }
    return e;
  }, e;
}
function bo() {
  var e = ma();
  return e.copy = () => ya(e, bo()), fo.apply(e, arguments), vo(e);
}
function _o() {
  var e, n = 0, t = 1, r = 1, o = [0.5], i = [0, 1];
  function s(u) {
    return u != null && u <= u ? i[lo(o, u, 0, r)] : e;
  }
  function a() {
    var u = -1;
    for (o = new Array(r); ++u < r; )
      o[u] = ((u + 1) * t - (u - r) * n) / (r + 1);
    return s;
  }
  return s.domain = function(u) {
    return arguments.length ? ([n, t] = u, n = +n, t = +t, a()) : [n, t];
  }, s.range = function(u) {
    return arguments.length ? (r = (i = Array.from(u)).length - 1, a()) : i.slice();
  }, s.invertExtent = (u) => {
    var c = i.indexOf(u);
    return c < 0 ? [NaN, NaN] : c < 1 ? [n, o[0]] : c >= r ? [o[r - 1], t] : [o[c - 1], o[c]];
  }, s.unknown = function(u) {
    return arguments.length && (e = u), s;
  }, s.thresholds = () => o.slice(), s.copy = () => _o().domain([n, t]).range(i).unknown(e), fo.apply(vo(s), arguments);
}
const wo = typeof global == "object" && global && global.Object === Object && global;
var va = typeof self == "object" && self && self.Object === Object && self;
const Se = wo || va || Function("return this")(), Nn = Se.Symbol;
var xo = Object.prototype, ba = xo.hasOwnProperty, _a = xo.toString, Je = Nn ? Nn.toStringTag : void 0, wa = Object.prototype.toString, xr = Nn ? Nn.toStringTag : void 0;
function $e(e) {
  return e == null ? e === void 0 ? "[object Undefined]" : "[object Null]" : xr && xr in Object(e) ? function(n) {
    var t = ba.call(n, Je), r = n[Je];
    try {
      n[Je] = void 0;
      var o = !0;
    } catch {
    }
    var i = _a.call(n);
    return o && (t ? n[Je] = r : delete n[Je]), i;
  }(e) : function(n) {
    return wa.call(n);
  }(e);
}
function ln(e) {
  return e != null && typeof e == "object";
}
function So(e) {
  return e;
}
var Sr, Or, xa = Object.prototype;
function Mr(e) {
  var n = e && e.constructor;
  return e === (typeof n == "function" && n.prototype || xa);
}
const Sa = (Sr = Object.keys, Or = Object, (e) => Sr(Or(e)));
var Oa = Object.prototype.hasOwnProperty;
function $n(e) {
  var n = typeof e;
  return e != null && (n == "object" || n == "function");
}
function Oo(e) {
  if (!$n(e))
    return !1;
  var n = $e(e);
  return n == "[object Function]" || n == "[object GeneratorFunction]" || n == "[object AsyncFunction]" || n == "[object Proxy]";
}
const Jn = Se["__core-js_shared__"];
var jr, Er = (jr = /[^.]+$/.exec(Jn && Jn.keys && Jn.keys.IE_PROTO || "")) ? "Symbol(src)_1." + jr : "", Ma = Function.prototype.toString;
function Te(e) {
  if (e != null) {
    try {
      return Ma.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var ja = /^\[object .+?Constructor\]$/, Ea = Function.prototype, ka = Object.prototype, Aa = Ea.toString, Na = ka.hasOwnProperty, $a = RegExp("^" + Aa.call(Na).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function Ta(e) {
  return !(!$n(e) || function(n) {
    return !!Er && Er in n;
  }(e)) && (Oo(e) ? $a : ja).test(Te(e));
}
function fn(e, n) {
  var t = function(r, o) {
    return r == null ? void 0 : r[o];
  }(e, n);
  return Ta(t) ? t : void 0;
}
const pt = fn(Se, "DataView"), yt = fn(Se, "Map"), dt = fn(Se, "Promise"), mt = fn(Se, "Set"), gt = fn(Se, "WeakMap");
var Ca = Te(pt), Ia = Te(yt), Pa = Te(dt), Ra = Te(mt), Fa = Te(gt), je = $e;
(pt && je(new pt(new ArrayBuffer(1))) != "[object DataView]" || yt && je(new yt()) != "[object Map]" || dt && je(dt.resolve()) != "[object Promise]" || mt && je(new mt()) != "[object Set]" || gt && je(new gt()) != "[object WeakMap]") && (je = (e) => {
  var n = $e(e), t = n == "[object Object]" ? e.constructor : void 0, r = t ? Te(t) : "";
  if (r)
    switch (r) {
      case Ca:
        return "[object DataView]";
      case Ia:
        return "[object Map]";
      case Pa:
        return "[object Promise]";
      case Ra:
        return "[object Set]";
      case Fa:
        return "[object WeakMap]";
    }
  return n;
});
const Va = je;
function kr(e) {
  return ln(e) && $e(e) == "[object Arguments]";
}
var Mo = Object.prototype, Da = Mo.hasOwnProperty, qa = Mo.propertyIsEnumerable;
const La = kr(function() {
  return arguments;
}()) ? kr : (e) => ln(e) && Da.call(e, "callee") && !qa.call(e, "callee"), Et = Array.isArray;
function jo(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= 9007199254740991;
}
var Eo = typeof exports == "object" && exports && !exports.nodeType && exports, Ar = Eo && typeof module == "object" && module && !module.nodeType && module, Nr = Ar && Ar.exports === Eo ? Se.Buffer : void 0;
const za = (Nr ? Nr.isBuffer : void 0) || function() {
  return !1;
};
var J = {};
J["[object Float32Array]"] = J["[object Float64Array]"] = J["[object Int8Array]"] = J["[object Int16Array]"] = J["[object Int32Array]"] = J["[object Uint8Array]"] = J["[object Uint8ClampedArray]"] = J["[object Uint16Array]"] = J["[object Uint32Array]"] = !0, J["[object Arguments]"] = J["[object Array]"] = J["[object ArrayBuffer]"] = J["[object Boolean]"] = J["[object DataView]"] = J["[object Date]"] = J["[object Error]"] = J["[object Function]"] = J["[object Map]"] = J["[object Number]"] = J["[object Object]"] = J["[object RegExp]"] = J["[object Set]"] = J["[object String]"] = J["[object WeakMap]"] = !1;
var ko = typeof exports == "object" && exports && !exports.nodeType && exports, on = ko && typeof module == "object" && module && !module.nodeType && module, Zn = on && on.exports === ko && wo.process, $r = (() => {
  try {
    var e = on && on.require && on.require("util").types;
    return e || Zn && Zn.binding && Zn.binding("util");
  } catch {
  }
})(), Tr = $r && $r.isTypedArray, Wa = Tr ? function(e) {
  return (n) => e(n);
}(Tr) : function(e) {
  return ln(e) && jo(e.length) && !!J[$e(e)];
};
const Ba = Wa;
var Ua = Object.prototype.hasOwnProperty;
function vt(e) {
  if (e == null)
    return !0;
  if (function(r) {
    return r != null && jo(r.length) && !Oo(r);
  }(e) && (Et(e) || typeof e == "string" || typeof e.splice == "function" || za(e) || Ba(e) || La(e)))
    return !e.length;
  var n = Va(e);
  if (n == "[object Map]" || n == "[object Set]")
    return !e.size;
  if (Mr(e))
    return !function(r) {
      if (!Mr(r))
        return Sa(r);
      var o = [];
      for (var i in Object(r))
        Oa.call(r, i) && i != "constructor" && o.push(i);
      return o;
    }(e).length;
  for (var t in e)
    if (Ua.call(e, t))
      return !1;
  return !0;
}
function Ao(e) {
  var n = e == null ? 0 : e.length;
  return n ? e[n - 1] : void 0;
}
function No(e, n, t) {
  var r = -1, o = e.length;
  n < 0 && (n = -n > o ? 0 : o + n), (t = t > o ? o : t) < 0 && (t += o), o = n > t ? 0 : t - n >>> 0, n >>>= 0;
  for (var i = Array(o); ++r < o; )
    i[r] = e[r + n];
  return i;
}
var Ha = /\s/, Ya = /^\s+/;
function Xa(e) {
  return e && e.slice(0, function(n) {
    for (var t = n.length; t-- && Ha.test(n.charAt(t)); )
      ;
    return t;
  }(e) + 1).replace(Ya, "");
}
var Qa = /^[-+]0x[0-9a-f]+$/i, Ga = /^0b[01]+$/i, Ja = /^0o[0-7]+$/i, Za = parseInt;
function Ka(e) {
  if (typeof e == "number")
    return e;
  if (function(r) {
    return typeof r == "symbol" || ln(r) && $e(r) == "[object Symbol]";
  }(e))
    return NaN;
  if ($n(e)) {
    var n = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = $n(n) ? n + "" : n;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Xa(e);
  var t = Ga.test(e);
  return t || Ja.test(e) ? Za(e.slice(2), t ? 2 : 8) : Qa.test(e) ? NaN : +e;
}
function kt(e) {
  var n = function(r) {
    return r ? (r = Ka(r)) === 1 / 0 || r === -1 / 0 ? 17976931348623157e292 * (r < 0 ? -1 : 1) : r == r ? r : 0 : r === 0 ? r : 0;
  }(e), t = n % 1;
  return n == n ? t ? n - t : n : 0;
}
var es = Math.min;
function ns(e, n) {
  if ((e = kt(e)) < 1 || e > 9007199254740991)
    return [];
  var t, r = 4294967295, o = es(e, 4294967295);
  e -= 4294967295;
  for (var i = function(s, a) {
    for (var u = -1, c = Array(s); ++u < s; )
      c[u] = a(u);
    return c;
  }(o, n = typeof (t = n) == "function" ? t : So); ++r < e; )
    n(r);
  return i;
}
function Tn(e, n) {
  return function(t) {
    return t && t.length ? ((r, o) => {
      for (var i, s = -1, a = r.length; ++s < a; ) {
        var u = o(r[s]);
        u !== void 0 && (i = i === void 0 ? u : i + u);
      }
      return i;
    })(t, So) : 0;
  }(function(t, r, o) {
    return t && t.length ? No(t, 0, (r = o || r === void 0 ? 1 : kt(r)) < 0 ? 0 : r) : [];
  }(e, n));
}
function ts({ tickData: e, customSegmentStops: n, min: t, max: r }) {
  if (!Et(n) || vt(n))
    return e;
  if (function(o) {
    return o && o.length ? o[0] : void 0;
  }(n) !== t)
    throw new Error(`First value should be equivalent to min value given. Current min value - ${t}`);
  if (Ao(n) !== r)
    throw new Error(`Last value should be equivalent to max value given. Current min value - ${r}`);
  return function(o, i, s) {
    var a = o == null ? 0 : o.length;
    return a ? No(o, (i = s || i === void 0 ? 1 : kt(i)) < 0 ? 0 : i, a) : [];
  }(n.map((o, i) => {
    if (i !== 0)
      return (o - n[i - 1]) / (r - t);
  }));
}
function rs({ maxSegmentLabelCount: e, segmentCount: n }) {
  const t = parseInt(e, 10), r = parseInt(n, 10);
  return (typeof (o = t) == "number" || ln(o) && $e(o) == "[object Number]") && t >= 0 && t <= r ? t : r;
  var o;
}
function os({ min: e, max: n, segments: t }) {
  return bo().range([0, 1]).domain([e, n]);
}
function Cr(e) {
  return e * Math.PI / 180;
}
const Fu = { Inside: "INSIDE", Outside: "OUTSIDE" }, Y = { easeLinear: "easeLinear", easeQuadIn: "easeQuadIn", easeQuadOut: "easeQuadOut", easeQuadInOut: "easeQuadInOut", easeCubicIn: "easeCubicIn", easeCubicOut: "easeCubicOut", easeCubicInOut: "easeCubicInOut", easePolyIn: "easePolyIn", easePolyOut: "easePolyOut", easePolyInOut: "easePolyInOut", easeSinIn: "easeSinIn", easeSinOut: "easeSinOut", easeSinInOut: "easeSinInOut", easeExpIn: "easeExpIn", easeExpOut: "easeExpOut", easeExpInOut: "easeExpInOut", easeCircleIn: "easeCircleIn", easeCircleOut: "easeCircleOut", easeCircleInOut: "easeCircleInOut", easeBounceIn: "easeBounceIn", easeBounceOut: "easeBounceOut", easeBounceInOut: "easeBounceInOut", easeBackIn: "easeBackIn", easeBackOut: "easeBackOut", easeBackInOut: "easeBackInOut", easeElasticIn: "easeElasticIn", easeElasticOut: "easeElasticOut", easeElasticInOut: "easeElasticInOut", easeElastic: "easeElastic" }, $o = (e) => e, is = { value: 0, minValue: 0, maxValue: 1e3, forceRender: !1, width: 300, height: 300, paddingHorizontal: 0, paddingVertical: 0, fluidWidth: !1, dimensionUnit: "px", segments: 5, maxSegmentLabels: -1, customSegmentStops: [], customSegmentLabels: [], needleColor: "steelblue", startColor: "#FF471A", endColor: "#33CC33", segmentColors: [], needleTransition: Y.easeQuadInOut, needleTransitionDuration: 500, needleHeightRatio: 0.9, ringWidth: 60, textColor: "#666", valueFormat: "", segmentValueFormatter: $o, currentValueText: "${value}", currentValuePlaceholderStyle: "${value}", labelFontSize: "14px", valueTextFontSize: "16px", valueTextFontWeight: "bold", svgAriaLabel: "React d3 speedometer" }, as = { ringInset: 20, pointerWidth: 10, pointerTailLength: 5, minAngle: -90, maxAngle: 90, labelInset: 10 }, bt = Math.PI, _t = 2 * bt, ss = _t - 1e-6;
function wt() {
  this._x0 = this._y0 = this._x1 = this._y1 = null, this._ = "";
}
function At() {
  return new wt();
}
function ce(e) {
  return function() {
    return e;
  };
}
wt.prototype = At.prototype = { constructor: wt, moveTo: function(e, n) {
  this._ += "M" + (this._x0 = this._x1 = +e) + "," + (this._y0 = this._y1 = +n);
}, closePath: function() {
  this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
}, lineTo: function(e, n) {
  this._ += "L" + (this._x1 = +e) + "," + (this._y1 = +n);
}, quadraticCurveTo: function(e, n, t, r) {
  this._ += "Q" + +e + "," + +n + "," + (this._x1 = +t) + "," + (this._y1 = +r);
}, bezierCurveTo: function(e, n, t, r, o, i) {
  this._ += "C" + +e + "," + +n + "," + +t + "," + +r + "," + (this._x1 = +o) + "," + (this._y1 = +i);
}, arcTo: function(e, n, t, r, o) {
  e = +e, n = +n, t = +t, r = +r, o = +o;
  var i = this._x1, s = this._y1, a = t - e, u = r - n, c = i - e, h = s - n, l = c * c + h * h;
  if (o < 0)
    throw new Error("negative radius: " + o);
  if (this._x1 === null)
    this._ += "M" + (this._x1 = e) + "," + (this._y1 = n);
  else if (l > 1e-6)
    if (Math.abs(h * a - u * c) > 1e-6 && o) {
      var f = t - i, y = r - s, b = a * a + u * u, g = f * f + y * y, _ = Math.sqrt(b), S = Math.sqrt(l), x = o * Math.tan((bt - Math.acos((b + l - g) / (2 * _ * S))) / 2), C = x / S, v = x / _;
      Math.abs(C - 1) > 1e-6 && (this._ += "L" + (e + C * c) + "," + (n + C * h)), this._ += "A" + o + "," + o + ",0,0," + +(h * f > c * y) + "," + (this._x1 = e + v * a) + "," + (this._y1 = n + v * u);
    } else
      this._ += "L" + (this._x1 = e) + "," + (this._y1 = n);
}, arc: function(e, n, t, r, o, i) {
  e = +e, n = +n, i = !!i;
  var s = (t = +t) * Math.cos(r), a = t * Math.sin(r), u = e + s, c = n + a, h = 1 ^ i, l = i ? r - o : o - r;
  if (t < 0)
    throw new Error("negative radius: " + t);
  this._x1 === null ? this._ += "M" + u + "," + c : (Math.abs(this._x1 - u) > 1e-6 || Math.abs(this._y1 - c) > 1e-6) && (this._ += "L" + u + "," + c), t && (l < 0 && (l = l % _t + _t), l > ss ? this._ += "A" + t + "," + t + ",0,1," + h + "," + (e - s) + "," + (n - a) + "A" + t + "," + t + ",0,1," + h + "," + (this._x1 = u) + "," + (this._y1 = c) : l > 1e-6 && (this._ += "A" + t + "," + t + ",0," + +(l >= bt) + "," + h + "," + (this._x1 = e + t * Math.cos(o)) + "," + (this._y1 = n + t * Math.sin(o))));
}, rect: function(e, n, t, r) {
  this._ += "M" + (this._x0 = this._x1 = +e) + "," + (this._y0 = this._y1 = +n) + "h" + +t + "v" + +r + "h" + -t + "Z";
}, toString: function() {
  return this._;
} };
const Ir = Math.abs, ae = Math.atan2, Me = Math.cos, us = Math.max, Kn = Math.min, de = Math.sin, We = Math.sqrt, un = Math.PI, Cn = un / 2, cs = 2 * un;
function ls(e) {
  return e > 1 ? 0 : e < -1 ? un : Math.acos(e);
}
function Pr(e) {
  return e >= 1 ? Cn : e <= -1 ? -Cn : Math.asin(e);
}
function fs(e) {
  return e.innerRadius;
}
function hs(e) {
  return e.outerRadius;
}
function ps(e) {
  return e.startAngle;
}
function ys(e) {
  return e.endAngle;
}
function ds(e) {
  return e && e.padAngle;
}
function ms(e, n, t, r, o, i, s, a) {
  var u = t - e, c = r - n, h = s - o, l = a - i, f = l * u - h * c;
  if (!(f * f < 1e-12))
    return [e + (f = (h * (n - i) - l * (e - o)) / f) * u, n + f * c];
}
function mn(e, n, t, r, o, i, s) {
  var a = e - t, u = n - r, c = (s ? i : -i) / We(a * a + u * u), h = c * u, l = -c * a, f = e + h, y = n + l, b = t + h, g = r + l, _ = (f + b) / 2, S = (y + g) / 2, x = b - f, C = g - y, v = x * x + C * C, d = o - i, p = f * g - b * y, j = (C < 0 ? -1 : 1) * We(us(0, d * d * v - p * p)), M = (p * C - x * j) / v, E = (-p * x - C * j) / v, k = (p * C + x * j) / v, I = (-p * x + C * j) / v, w = M - _, N = E - S, R = k - _, T = I - S;
  return w * w + N * N > R * R + T * T && (M = k, E = I), { cx: M, cy: E, x01: -h, y01: -l, x11: M * (o / d - 1), y11: E * (o / d - 1) };
}
function To(e) {
  this._context = e;
}
function gs(e) {
  return new To(e);
}
function vs(e) {
  return e[0];
}
function bs(e) {
  return e[1];
}
function _s(e, n) {
  var t = ce(!0), r = null, o = gs, i = null;
  function s(a) {
    var u, c, h, l = (a = function(y) {
      return typeof y == "object" && "length" in y ? y : Array.from(y);
    }(a)).length, f = !1;
    for (r == null && (i = o(h = At())), u = 0; u <= l; ++u)
      !(u < l && t(c = a[u], u, a)) === f && ((f = !f) ? i.lineStart() : i.lineEnd()), f && i.point(+e(c, u, a), +n(c, u, a));
    if (h)
      return i = null, h + "" || null;
  }
  return e = typeof e == "function" ? e : e === void 0 ? vs : ce(e), n = typeof n == "function" ? n : n === void 0 ? bs : ce(n), s.x = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : ce(+a), s) : e;
  }, s.y = function(a) {
    return arguments.length ? (n = typeof a == "function" ? a : ce(+a), s) : n;
  }, s.defined = function(a) {
    return arguments.length ? (t = typeof a == "function" ? a : ce(!!a), s) : t;
  }, s.curve = function(a) {
    return arguments.length ? (o = a, r != null && (i = o(r)), s) : o;
  }, s.context = function(a) {
    return arguments.length ? (a == null ? r = i = null : i = o(r = a), s) : r;
  }, s;
}
function Rr(e) {
  return e < 0 ? -1 : 1;
}
function Fr(e, n, t) {
  var r = e._x1 - e._x0, o = n - e._x1, i = (e._y1 - e._y0) / (r || o < 0 && -0), s = (t - e._y1) / (o || r < 0 && -0), a = (i * o + s * r) / (r + o);
  return (Rr(i) + Rr(s)) * Math.min(Math.abs(i), Math.abs(s), 0.5 * Math.abs(a)) || 0;
}
function Vr(e, n) {
  var t = e._x1 - e._x0;
  return t ? (3 * (e._y1 - e._y0) / t - n) / 2 : n;
}
function et(e, n, t) {
  var r = e._x0, o = e._y0, i = e._x1, s = e._y1, a = (i - r) / 3;
  e._context.bezierCurveTo(r + a, o + a * n, i - a, s - a * t, i, s);
}
function _n(e) {
  this._context = e;
}
function ws(e) {
  return new _n(e);
}
To.prototype = { areaStart: function() {
  this._line = 0;
}, areaEnd: function() {
  this._line = NaN;
}, lineStart: function() {
  this._point = 0;
}, lineEnd: function() {
  (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
}, point: function(e, n) {
  switch (e = +e, n = +n, this._point) {
    case 0:
      this._point = 1, this._line ? this._context.lineTo(e, n) : this._context.moveTo(e, n);
      break;
    case 1:
      this._point = 2;
    default:
      this._context.lineTo(e, n);
  }
} }, _n.prototype = { areaStart: function() {
  this._line = 0;
}, areaEnd: function() {
  this._line = NaN;
}, lineStart: function() {
  this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
}, lineEnd: function() {
  switch (this._point) {
    case 2:
      this._context.lineTo(this._x1, this._y1);
      break;
    case 3:
      et(this, this._t0, Vr(this, this._t0));
  }
  (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
}, point: function(e, n) {
  var t = NaN;
  if (n = +n, (e = +e) !== this._x1 || n !== this._y1) {
    switch (this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, n) : this._context.moveTo(e, n);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, et(this, Vr(this, t = Fr(this, e, n)), t);
        break;
      default:
        et(this, this._t0, t = Fr(this, e, n));
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = n, this._t0 = t;
  }
} }, Object.create(_n.prototype).point = function(e, n) {
  _n.prototype.point.call(this, n, e);
};
var xs = { value: () => {
} };
function Co() {
  for (var e, n = 0, t = arguments.length, r = {}; n < t; ++n) {
    if (!(e = arguments[n] + "") || e in r || /[\s.]/.test(e))
      throw new Error("illegal type: " + e);
    r[e] = [];
  }
  return new wn(r);
}
function wn(e) {
  this._ = e;
}
function Ss(e, n) {
  return e.trim().split(/^|\s+/).map((t) => {
    var r = "", o = t.indexOf(".");
    if (o >= 0 && (r = t.slice(o + 1), t = t.slice(0, o)), t && !n.hasOwnProperty(t))
      throw new Error("unknown type: " + t);
    return { type: t, name: r };
  });
}
function Os(e, n) {
  for (var t, r = 0, o = e.length; r < o; ++r)
    if ((t = e[r]).name === n)
      return t.value;
}
function Dr(e, n, t) {
  for (var r = 0, o = e.length; r < o; ++r)
    if (e[r].name === n) {
      e[r] = xs, e = e.slice(0, r).concat(e.slice(r + 1));
      break;
    }
  return t != null && e.push({ name: n, value: t }), e;
}
wn.prototype = Co.prototype = { constructor: wn, on: function(e, n) {
  var t, r = this._, o = Ss(e + "", r), i = -1, s = o.length;
  if (!(arguments.length < 2)) {
    if (n != null && typeof n != "function")
      throw new Error("invalid callback: " + n);
    for (; ++i < s; )
      if (t = (e = o[i]).type)
        r[t] = Dr(r[t], e.name, n);
      else if (n == null)
        for (t in r)
          r[t] = Dr(r[t], e.name, null);
    return this;
  }
  for (; ++i < s; )
    if ((t = (e = o[i]).type) && (t = Os(r[t], e.name)))
      return t;
}, copy: function() {
  var e = {}, n = this._;
  for (var t in n)
    e[t] = n[t].slice();
  return new wn(e);
}, call: function(e, n) {
  if ((t = arguments.length - 2) > 0)
    for (var t, r, o = new Array(t), i = 0; i < t; ++i)
      o[i] = arguments[i + 2];
  if (!this._.hasOwnProperty(e))
    throw new Error("unknown type: " + e);
  for (i = 0, t = (r = this._[e]).length; i < t; ++i)
    r[i].value.apply(n, o);
}, apply: function(e, n, t) {
  if (!this._.hasOwnProperty(e))
    throw new Error("unknown type: " + e);
  for (var r = this._[e], o = 0, i = r.length; o < i; ++o)
    r[o].value.apply(n, t);
} };
var xn, en, Be = 0, nn = 0, Ze = 0, In = 0, Ae = 0, Vn = 0, cn = typeof performance == "object" && performance.now ? performance : Date, Io = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : (e) => {
  setTimeout(e, 17);
};
function Nt() {
  return Ae || (Io(Ms), Ae = cn.now() + Vn);
}
function Ms() {
  Ae = 0;
}
function Pn() {
  this._call = this._time = this._next = null;
}
function Po(e, n, t) {
  var r = new Pn();
  return r.restart(e, n, t), r;
}
function qr() {
  Ae = (In = cn.now()) + Vn, Be = nn = 0;
  try {
    (function() {
      Nt(), ++Be;
      for (var e, n = xn; n; )
        (e = Ae - n._time) >= 0 && n._call.call(void 0, e), n = n._next;
      --Be;
    })();
  } finally {
    Be = 0, function() {
      for (var e, n, t = xn, r = 1 / 0; t; )
        t._call ? (r > t._time && (r = t._time), e = t, t = t._next) : (n = t._next, t._next = null, t = e ? e._next = n : xn = n);
      en = e, xt(r);
    }(), Ae = 0;
  }
}
function js() {
  var e = cn.now(), n = e - In;
  n > 1e3 && (Vn -= n, In = e);
}
function xt(e) {
  Be || (nn && (nn = clearTimeout(nn)), e - Ae > 24 ? (e < 1 / 0 && (nn = setTimeout(qr, e - cn.now() - Vn)), Ze && (Ze = clearInterval(Ze))) : (Ze || (In = cn.now(), Ze = setInterval(js, 1e3)), Be = 1, Io(qr)));
}
function Lr(e, n, t) {
  var r = new Pn();
  return n = n == null ? 0 : +n, r.restart((o) => {
    r.stop(), e(o + n);
  }, n, t), r;
}
Pn.prototype = Po.prototype = { constructor: Pn, restart: function(e, n, t) {
  if (typeof e != "function")
    throw new TypeError("callback is not a function");
  t = (t == null ? Nt() : +t) + (n == null ? 0 : +n), this._next || en === this || (en ? en._next = this : xn = this, en = this), this._call = e, this._time = t, xt();
}, stop: function() {
  this._call && (this._call = null, this._time = 1 / 0, xt());
} };
var Es = Co("start", "end", "cancel", "interrupt"), ks = [];
function Sn(e, n, t, r, o, i) {
  var s = e.__transition;
  if (s) {
    if (t in s)
      return;
  } else
    e.__transition = {};
  (function(a, u, c) {
    var h, l = a.__transition;
    function f(_) {
      c.state = 1, c.timer.restart(y, c.delay, c.time), c.delay <= _ && y(_ - c.delay);
    }
    function y(_) {
      var S, x, C, v;
      if (c.state !== 1)
        return g();
      for (S in l)
        if ((v = l[S]).name === c.name) {
          if (v.state === 3)
            return Lr(y);
          v.state === 4 ? (v.state = 6, v.timer.stop(), v.on.call("interrupt", a, a.__data__, v.index, v.group), delete l[S]) : +S < u && (v.state = 6, v.timer.stop(), v.on.call("cancel", a, a.__data__, v.index, v.group), delete l[S]);
        }
      if (Lr(() => {
        c.state === 3 && (c.state = 4, c.timer.restart(b, c.delay, c.time), b(_));
      }), c.state = 2, c.on.call("start", a, a.__data__, c.index, c.group), c.state === 2) {
        for (c.state = 3, h = new Array(C = c.tween.length), S = 0, x = -1; S < C; ++S)
          (v = c.tween[S].value.call(a, a.__data__, c.index, c.group)) && (h[++x] = v);
        h.length = x + 1;
      }
    }
    function b(_) {
      for (var S = _ < c.duration ? c.ease.call(null, _ / c.duration) : (c.timer.restart(g), c.state = 5, 1), x = -1, C = h.length; ++x < C; )
        h[x].call(a, S);
      c.state === 5 && (c.on.call("end", a, a.__data__, c.index, c.group), g());
    }
    function g() {
      for (var _ in c.state = 6, c.timer.stop(), delete l[u], l)
        return;
      delete a.__transition;
    }
    l[u] = c, c.timer = Po(f, 0, c.time);
  })(e, t, { name: n, index: r, group: o, on: Es, tween: ks, time: i.time, delay: i.delay, duration: i.duration, ease: i.ease, timer: null, state: 0 });
}
function $t(e, n) {
  var t = he(e, n);
  if (t.state > 0)
    throw new Error("too late; already scheduled");
  return t;
}
function ge(e, n) {
  var t = he(e, n);
  if (t.state > 3)
    throw new Error("too late; already running");
  return t;
}
function he(e, n) {
  var t = e.__transition;
  if (!t || !(t = t[n]))
    throw new Error("transition not found");
  return t;
}
function As(e, n) {
  var t, r;
  return function() {
    var o = ge(this, e), i = o.tween;
    if (i !== t) {
      for (var s = 0, a = (r = t = i).length; s < a; ++s)
        if (r[s].name === n) {
          (r = r.slice()).splice(s, 1);
          break;
        }
    }
    o.tween = r;
  };
}
function Ns(e, n, t) {
  var r, o;
  if (typeof t != "function")
    throw new Error();
  return function() {
    var i = ge(this, e), s = i.tween;
    if (s !== r) {
      o = (r = s).slice();
      for (var a = { name: n, value: t }, u = 0, c = o.length; u < c; ++u)
        if (o[u].name === n) {
          o[u] = a;
          break;
        }
      u === c && o.push(a);
    }
    i.tween = o;
  };
}
function nt(e, n, t) {
  var r = e._id;
  return e.each(function() {
    var o = ge(this, r);
    (o.value || (o.value = {}))[n] = t.apply(this, arguments);
  }), (o) => he(o, r).value[n];
}
function zr(e, n) {
  var t;
  return (typeof n == "number" ? pe : n instanceof Ne ? An : (t = Ne(n)) ? (n = t, An) : yo)(e, n);
}
function $s(e) {
  return function() {
    this.removeAttribute(e);
  };
}
function Ts(e) {
  return function() {
    this.removeAttributeNS(e.space, e.local);
  };
}
function Cs(e, n, t) {
  var r, o, i = t + "";
  return function() {
    var s = this.getAttribute(e);
    return s === i ? null : s === r ? o : o = n(r = s, t);
  };
}
function Is(e, n, t) {
  var r, o, i = t + "";
  return function() {
    var s = this.getAttributeNS(e.space, e.local);
    return s === i ? null : s === r ? o : o = n(r = s, t);
  };
}
function Ps(e, n, t) {
  var r, o, i;
  return function() {
    var s, a, u = t(this);
    if (u != null)
      return (s = this.getAttribute(e)) === (a = u + "") ? null : s === r && a === o ? i : (o = a, i = n(r = s, u));
    this.removeAttribute(e);
  };
}
function Rs(e, n, t) {
  var r, o, i;
  return function() {
    var s, a, u = t(this);
    if (u != null)
      return (s = this.getAttributeNS(e.space, e.local)) === (a = u + "") ? null : s === r && a === o ? i : (o = a, i = n(r = s, u));
    this.removeAttributeNS(e.space, e.local);
  };
}
function Fs(e, n) {
  return function(t) {
    this.setAttribute(e, n.call(this, t));
  };
}
function Vs(e, n) {
  return function(t) {
    this.setAttributeNS(e.space, e.local, n.call(this, t));
  };
}
function Ds(e, n) {
  var t, r;
  function o() {
    var i = n.apply(this, arguments);
    return i !== r && (t = (r = i) && Vs(e, i)), t;
  }
  return o._value = n, o;
}
function qs(e, n) {
  var t, r;
  function o() {
    var i = n.apply(this, arguments);
    return i !== r && (t = (r = i) && Fs(e, i)), t;
  }
  return o._value = n, o;
}
function Ls(e, n) {
  return function() {
    $t(this, e).delay = +n.apply(this, arguments);
  };
}
function zs(e, n) {
  return n = +n, function() {
    $t(this, e).delay = n;
  };
}
function Ws(e, n) {
  return function() {
    ge(this, e).duration = +n.apply(this, arguments);
  };
}
function Bs(e, n) {
  return n = +n, function() {
    ge(this, e).duration = n;
  };
}
function Us(e, n) {
  if (typeof n != "function")
    throw new Error();
  return function() {
    ge(this, e).ease = n;
  };
}
function Hs(e, n, t) {
  var r, o, i = function(s) {
    return (s + "").trim().split(/^|\s+/).every((a) => {
      var u = a.indexOf(".");
      return u >= 0 && (a = a.slice(0, u)), !a || a === "start";
    });
  }(n) ? $t : ge;
  return function() {
    var s = i(this, e), a = s.on;
    a !== r && (o = (r = a).copy()).on(n, t), s.on = o;
  };
}
var Ys = He.prototype.constructor;
function Wr(e) {
  return function() {
    this.style.removeProperty(e);
  };
}
function Xs(e, n, t) {
  return function(r) {
    this.style.setProperty(e, n.call(this, r), t);
  };
}
function Qs(e, n, t) {
  var r, o;
  function i() {
    var s = n.apply(this, arguments);
    return s !== o && (r = (o = s) && Xs(e, s, t)), r;
  }
  return i._value = n, i;
}
function Gs(e) {
  return function(n) {
    this.textContent = e.call(this, n);
  };
}
function Js(e) {
  var n, t;
  function r() {
    var o = e.apply(this, arguments);
    return o !== t && (n = (t = o) && Gs(o)), n;
  }
  return r._value = e, r;
}
var Zs = 0;
function _e(e, n, t, r) {
  this._groups = e, this._parents = n, this._name = t, this._id = r;
}
function Ro(e) {
  return He().transition(e);
}
function Fo() {
  return ++Zs;
}
var be = He.prototype;
_e.prototype = Ro.prototype = { constructor: _e, select: function(e) {
  var n = this._name, t = this._id;
  typeof e != "function" && (e = ot(e));
  for (var r = this._groups, o = r.length, i = new Array(o), s = 0; s < o; ++s)
    for (var a, u, c = r[s], h = c.length, l = i[s] = new Array(h), f = 0; f < h; ++f)
      (a = c[f]) && (u = e.call(a, a.__data__, f, c)) && ("__data__" in a && (u.__data__ = a.__data__), l[f] = u, Sn(l[f], n, t, f, l, he(a, t)));
  return new _e(i, this._parents, n, t);
}, selectAll: function(e) {
  var n = this._name, t = this._id;
  typeof e != "function" && (e = Kr(e));
  for (var r = this._groups, o = r.length, i = [], s = [], a = 0; a < o; ++a)
    for (var u, c = r[a], h = c.length, l = 0; l < h; ++l)
      if (u = c[l]) {
        for (var f, y = e.call(u, u.__data__, l, c), b = he(u, t), g = 0, _ = y.length; g < _; ++g)
          (f = y[g]) && Sn(f, n, t, g, y, b);
        i.push(y), s.push(u);
      }
  return new _e(i, s, n, t);
}, selectChild: be.selectChild, selectChildren: be.selectChildren, filter: function(e) {
  typeof e != "function" && (e = eo(e));
  for (var n = this._groups, t = n.length, r = new Array(t), o = 0; o < t; ++o)
    for (var i, s = n[o], a = s.length, u = r[o] = [], c = 0; c < a; ++c)
      (i = s[c]) && e.call(i, i.__data__, c, s) && u.push(i);
  return new _e(r, this._parents, this._name, this._id);
}, merge: function(e) {
  if (e._id !== this._id)
    throw new Error();
  for (var n = this._groups, t = e._groups, r = n.length, o = t.length, i = Math.min(r, o), s = new Array(r), a = 0; a < i; ++a)
    for (var u, c = n[a], h = t[a], l = c.length, f = s[a] = new Array(l), y = 0; y < l; ++y)
      (u = c[y] || h[y]) && (f[y] = u);
  for (; a < r; ++a)
    s[a] = n[a];
  return new _e(s, this._parents, this._name, this._id);
}, selection: function() {
  return new Ys(this._groups, this._parents);
}, transition: function() {
  for (var e = this._name, n = this._id, t = Fo(), r = this._groups, o = r.length, i = 0; i < o; ++i)
    for (var s, a = r[i], u = a.length, c = 0; c < u; ++c)
      if (s = a[c]) {
        var h = he(s, n);
        Sn(s, e, t, c, a, { time: h.time + h.delay + h.duration, delay: 0, duration: h.duration, ease: h.ease });
      }
  return new _e(r, this._parents, e, t);
}, call: be.call, nodes: be.nodes, node: be.node, size: be.size, empty: be.empty, each: be.each, on: function(e, n) {
  var t = this._id;
  return arguments.length < 2 ? he(this.node(), t).on.on(e) : this.each(Hs(t, e, n));
}, attr: function(e, n) {
  var t = En(e), r = t === "transform" ? ca : zr;
  return this.attrTween(e, typeof n == "function" ? (t.local ? Rs : Ps)(t, r, nt(this, "attr." + e, n)) : n == null ? (t.local ? Ts : $s)(t) : (t.local ? Is : Cs)(t, r, n));
}, attrTween: function(e, n) {
  var t = "attr." + e;
  if (arguments.length < 2)
    return (t = this.tween(t)) && t._value;
  if (n == null)
    return this.tween(t, null);
  if (typeof n != "function")
    throw new Error();
  var r = En(e);
  return this.tween(t, (r.local ? Ds : qs)(r, n));
}, style: function(e, n, t) {
  var r = (e += "") == "transform" ? ua : zr;
  return n == null ? this.styleTween(e, function(o, i) {
    var s, a, u;
    return function() {
      var c = Le(this, o), h = (this.style.removeProperty(o), Le(this, o));
      return c === h ? null : c === s && h === a ? u : u = i(s = c, a = h);
    };
  }(e, r)).on("end.style." + e, Wr(e)) : typeof n == "function" ? this.styleTween(e, function(o, i, s) {
    var a, u, c;
    return function() {
      var h = Le(this, o), l = s(this), f = l + "";
      return l == null && (this.style.removeProperty(o), f = l = Le(this, o)), h === f ? null : h === a && f === u ? c : (u = f, c = i(a = h, l));
    };
  }(e, r, nt(this, "style." + e, n))).each(function(o, i) {
    var s, a, u, c, h = "style." + i, l = "end." + h;
    return function() {
      var f = ge(this, o), y = f.on, b = f.value[h] == null ? c || (c = Wr(i)) : void 0;
      y === s && u === b || (a = (s = y).copy()).on(l, u = b), f.on = a;
    };
  }(this._id, e)) : this.styleTween(e, function(o, i, s) {
    var a, u, c = s + "";
    return function() {
      var h = Le(this, o);
      return h === c ? null : h === a ? u : u = i(a = h, s);
    };
  }(e, r, n), t).on("end.style." + e, null);
}, styleTween: function(e, n, t) {
  var r = "style." + (e += "");
  if (arguments.length < 2)
    return (r = this.tween(r)) && r._value;
  if (n == null)
    return this.tween(r, null);
  if (typeof n != "function")
    throw new Error();
  return this.tween(r, Qs(e, n, t != null ? t : ""));
}, text: function(e) {
  return this.tween("text", typeof e == "function" ? function(n) {
    return function() {
      var t = n(this);
      this.textContent = t != null ? t : "";
    };
  }(nt(this, "text", e)) : function(n) {
    return function() {
      this.textContent = n;
    };
  }(e == null ? "" : e + ""));
}, textTween: function(e) {
  var n = "text";
  if (arguments.length < 1)
    return (n = this.tween(n)) && n._value;
  if (e == null)
    return this.tween(n, null);
  if (typeof e != "function")
    throw new Error();
  return this.tween(n, Js(e));
}, remove: function() {
  return this.on("end.remove", function(e) {
    return function() {
      var n = this.parentNode;
      for (var t in this.__transition)
        if (+t !== e)
          return;
      n && n.removeChild(this);
    };
  }(this._id));
}, tween: function(e, n) {
  var t = this._id;
  if (e += "", arguments.length < 2) {
    for (var r, o = he(this.node(), t).tween, i = 0, s = o.length; i < s; ++i)
      if ((r = o[i]).name === e)
        return r.value;
    return null;
  }
  return this.each((n == null ? As : Ns)(t, e, n));
}, delay: function(e) {
  var n = this._id;
  return arguments.length ? this.each((typeof e == "function" ? Ls : zs)(n, e)) : he(this.node(), n).delay;
}, duration: function(e) {
  var n = this._id;
  return arguments.length ? this.each((typeof e == "function" ? Ws : Bs)(n, e)) : he(this.node(), n).duration;
}, ease: function(e) {
  var n = this._id;
  return arguments.length ? this.each(Us(n, e)) : he(this.node(), n).ease;
}, easeVarying: function(e) {
  if (typeof e != "function")
    throw new Error();
  return this.each(function(n, t) {
    return function() {
      var r = t.apply(this, arguments);
      if (typeof r != "function")
        throw new Error();
      ge(this, n).ease = r;
    };
  }(this._id, e));
}, end: function() {
  var e, n, t = this, r = t._id, o = t.size();
  return new Promise(function(i, s) {
    var a = { value: s }, u = { value: () => {
      --o == 0 && i();
    } };
    t.each(function() {
      var c = ge(this, r), h = c.on;
      h !== e && ((n = (e = h).copy())._.cancel.push(a), n._.interrupt.push(a), n._.end.push(u)), c.on = n;
    }), o === 0 && i();
  });
}, [Symbol.iterator]: be[Symbol.iterator] };
const Ks = (e) => +e;
function eu(e) {
  return e * e;
}
function nu(e) {
  return e * (2 - e);
}
function Br(e) {
  return ((e *= 2) <= 1 ? e * e : --e * (2 - e) + 1) / 2;
}
function tu(e) {
  return e * e * e;
}
function ru(e) {
  return --e * e * e + 1;
}
function Vo(e) {
  return ((e *= 2) <= 1 ? e * e * e : (e -= 2) * e * e + 2) / 2;
}
var ou = function e(n) {
  function t(r) {
    return Math.pow(r, n);
  }
  return n = +n, t.exponent = e, t;
}(3), iu = function e(n) {
  function t(r) {
    return 1 - Math.pow(1 - r, n);
  }
  return n = +n, t.exponent = e, t;
}(3), au = function e(n) {
  function t(r) {
    return ((r *= 2) <= 1 ? Math.pow(r, n) : 2 - Math.pow(2 - r, n)) / 2;
  }
  return n = +n, t.exponent = e, t;
}(3), Do = Math.PI, qo = Do / 2;
function su(e) {
  return +e == 1 ? 1 : 1 - Math.cos(e * qo);
}
function uu(e) {
  return Math.sin(e * qo);
}
function cu(e) {
  return (1 - Math.cos(Do * e)) / 2;
}
function xe(e) {
  return 1.0009775171065494 * (Math.pow(2, -10 * e) - 9765625e-10);
}
function lu(e) {
  return xe(1 - +e);
}
function fu(e) {
  return 1 - xe(e);
}
function hu(e) {
  return ((e *= 2) <= 1 ? xe(1 - e) : 2 - xe(e - 1)) / 2;
}
function pu(e) {
  return 1 - Math.sqrt(1 - e * e);
}
function yu(e) {
  return Math.sqrt(1 - --e * e);
}
function du(e) {
  return ((e *= 2) <= 1 ? 1 - Math.sqrt(1 - e * e) : Math.sqrt(1 - (e -= 2) * e) + 1) / 2;
}
var mu = 4 / 11, gn = 7.5625;
function gu(e) {
  return 1 - Rn(1 - e);
}
function Rn(e) {
  return (e = +e) < mu ? gn * e * e : e < 0.7272727272727273 ? gn * (e -= 0.5454545454545454) * e + 0.75 : e < 0.9090909090909091 ? gn * (e -= 0.8181818181818182) * e + 0.9375 : gn * (e -= 0.9545454545454546) * e + 0.984375;
}
function vu(e) {
  return ((e *= 2) <= 1 ? 1 - Rn(1 - e) : Rn(e - 1) + 1) / 2;
}
var bu = function e(n) {
  function t(r) {
    return (r = +r) * r * (n * (r - 1) + r);
  }
  return n = +n, t.overshoot = e, t;
}(1.70158), _u = function e(n) {
  function t(r) {
    return --r * r * ((r + 1) * n + r) + 1;
  }
  return n = +n, t.overshoot = e, t;
}(1.70158), wu = function e(n) {
  function t(r) {
    return ((r *= 2) < 1 ? r * r * ((n + 1) * r - n) : (r -= 2) * r * ((n + 1) * r + n) + 2) / 2;
  }
  return n = +n, t.overshoot = e, t;
}(1.70158), Ye = 2 * Math.PI, xu = function e(n, t) {
  var r = Math.asin(1 / (n = Math.max(1, n))) * (t /= Ye);
  function o(i) {
    return n * xe(- --i) * Math.sin((r - i) / t);
  }
  return o.amplitude = (i) => e(i, t * Ye), o.period = (i) => e(n, i), o;
}(1, 0.3), Ur = function e(n, t) {
  var r = Math.asin(1 / (n = Math.max(1, n))) * (t /= Ye);
  function o(i) {
    return 1 - n * xe(i = +i) * Math.sin((i + r) / t);
  }
  return o.amplitude = (i) => e(i, t * Ye), o.period = (i) => e(n, i), o;
}(1, 0.3), Su = function e(n, t) {
  var r = Math.asin(1 / (n = Math.max(1, n))) * (t /= Ye);
  function o(i) {
    return ((i = 2 * i - 1) < 0 ? n * xe(-i) * Math.sin((r - i) / t) : 2 - n * xe(i) * Math.sin((r + i) / t)) / 2;
  }
  return o.amplitude = (i) => e(i, t * Ye), o.period = (i) => e(n, i), o;
}(1, 0.3), Ou = { time: null, delay: 0, duration: 250, ease: Vo };
function Mu(e, n) {
  for (var t; !(t = e.__transition) || !(t = t[n]); )
    if (!(e = e.parentNode))
      throw new Error(`transition ${n} not found`);
  return t;
}
function ju(e) {
  switch (e) {
    case Y.easeLinear:
      return Ks;
    case Y.easeQuadIn:
      return eu;
    case Y.easeQuadOut:
      return nu;
    case Y.easeQuadInOut:
      return Br;
    case Y.easeCubicIn:
      return tu;
    case Y.easeCubicOut:
      return ru;
    case Y.easeCubicInOut:
      return Vo;
    case Y.easePolyIn:
      return ou;
    case Y.easePolyOut:
      return iu;
    case Y.easePolyInOut:
      return au;
    case Y.easeSinIn:
      return su;
    case Y.easeSinOut:
      return uu;
    case Y.easeSinInOut:
      return cu;
    case Y.easeExpIn:
      return lu;
    case Y.easeExpOut:
      return fu;
    case Y.easeExpInOut:
      return hu;
    case Y.easeCircleIn:
      return pu;
    case Y.easeCircleOut:
      return yu;
    case Y.easeCircleInOut:
      return du;
    case Y.easeBounceIn:
      return gu;
    case Y.easeBounceOut:
      return Rn;
    case Y.easeBounceInOut:
      return vu;
    case Y.easeBackIn:
      return bu;
    case Y.easeBackOut:
      return _u;
    case Y.easeBackInOut:
      return wu;
    case Y.easeElasticIn:
      return xu;
    case Y.easeElasticOut:
      return Ur;
    case Y.easeElasticInOut:
      return Su;
    case Y.easeElastic:
      return Ur;
    default:
      return Br;
  }
}
He.prototype.interrupt = function(e) {
  return this.each(function() {
    (function(n, t) {
      var r, o, i, s = n.__transition, a = !0;
      if (s) {
        for (i in t = t == null ? null : t + "", s)
          (r = s[i]).name === t ? (o = r.state > 2 && r.state < 5, r.state = 6, r.timer.stop(), r.on.call(o ? "interrupt" : "cancel", n, n.__data__, r.index, r.group), delete s[i]) : a = !1;
        a && delete n.__transition;
      }
    })(this, e);
  });
}, He.prototype.transition = function(e) {
  var n, t;
  e instanceof _e ? (n = e._id, e = e._name) : (n = Fo(), (t = Ou).time = Nt(), e = e == null ? null : e + "");
  for (var r = this._groups, o = r.length, i = 0; i < o; ++i)
    for (var s, a = r[i], u = a.length, c = 0; c < u; ++c)
      (s = a[c]) && Sn(s, e, n, c, a, t || Mu(s, n));
  return new _e(r, this._parents, e, n);
};
var Hr = Number.isNaN || function(e) {
  return typeof e == "number" && e != e;
};
function Eu(e, n) {
  if (e.length !== n.length)
    return !1;
  for (var t = 0; t < e.length; t++)
    if (r = e[t], o = n[t], !(r === o || Hr(r) && Hr(o)))
      return !1;
  var r, o;
  return !0;
}
function Dn(e, n) {
  n === void 0 && (n = Eu);
  var t = null;
  function r() {
    for (var o = [], i = 0; i < arguments.length; i++)
      o[i] = arguments[i];
    if (t && t.lastThis === this && n(o, t.lastArgs))
      return t.lastResult;
    var s = e.apply(this, o);
    return t = { lastResult: s, lastArgs: o, lastThis: this }, s;
  }
  return r.clear = function() {
    t = null;
  }, r;
}
const Tt = Dn(function(e) {
  return os({ min: e.minValue, max: e.maxValue, segments: e.maxSegmentLabels });
}), ku = Dn(function(e) {
  let n = function(t, { min: r, max: o, segments: i }) {
    let s = [];
    if (s = t.ticks(i), (Ao(s) !== o || i < s.length) && s.length > 1) {
      const a = (o - r) / i;
      s = [r], ns(i, (u) => {
        s.push(r + (u + 1) * a);
      });
    }
    return s.length === 1 && (s = [r, o]), s;
  }(Tt(e), { min: e.minValue, max: e.maxValue, segments: e.maxSegmentLabels });
  return e.customSegmentStops.length > 0 && e.maxSegmentLabels !== 0 && (n = e.customSegmentStops), n;
}), St = Dn(function(e) {
  const n = function(t, r, o) {
    t = +t, r = +r, o = (s = arguments.length) < 2 ? (r = t, t = 0, 1) : s < 3 ? 1 : +o;
    for (var i = -1, s = 0 | Math.max(0, Math.ceil((r - t) / o)), a = new Array(s); ++i < s; )
      a[i] = t + i * o;
    return a;
  }(e.majorTicks).map((t) => 1 / e.majorTicks);
  return ts({ tickData: n, customSegmentStops: e.customSegmentStops, min: e.minValue, max: e.maxValue });
}), Au = Dn(function(e) {
  const n = St(e), t = e.maxAngle - e.minAngle, r = e.width / 2;
  return function() {
    var o = fs, i = hs, s = ce(0), a = null, u = ps, c = ys, h = ds, l = null;
    function f() {
      var y, b, g = +o.apply(this, arguments), _ = +i.apply(this, arguments), S = u.apply(this, arguments) - Cn, x = c.apply(this, arguments) - Cn, C = Ir(x - S), v = x > S;
      if (l || (l = y = At()), _ < g && (b = _, _ = g, g = b), _ > 1e-12)
        if (C > cs - 1e-12)
          l.moveTo(_ * Me(S), _ * de(S)), l.arc(0, 0, _, S, x, !v), g > 1e-12 && (l.moveTo(g * Me(x), g * de(x)), l.arc(0, 0, g, x, S, v));
        else {
          var d, p, j = S, M = x, E = S, k = x, I = C, w = C, N = h.apply(this, arguments) / 2, R = N > 1e-12 && (a ? +a.apply(this, arguments) : We(g * g + _ * _)), T = Kn(Ir(_ - g) / 2, +s.apply(this, arguments)), D = T, F = T;
          if (R > 1e-12) {
            var Z = Pr(R / g * de(N)), oe = Pr(R / _ * de(N));
            (I -= 2 * Z) > 1e-12 ? (E += Z *= v ? 1 : -1, k -= Z) : (I = 0, E = k = (S + x) / 2), (w -= 2 * oe) > 1e-12 ? (j += oe *= v ? 1 : -1, M -= oe) : (w = 0, j = M = (S + x) / 2);
          }
          var O = _ * Me(j), ne = _ * de(j), ie = g * Me(k), ue = g * de(k);
          if (T > 1e-12) {
            var te, se = _ * Me(M), ve = _ * de(M), Xe = g * Me(E), Oe = g * de(E);
            if (C < un && (te = ms(O, ne, Xe, Oe, se, ve, ie, ue))) {
              var Ce = O - te[0], Ie = ne - te[1], Pe = se - te[0], Re = ve - te[1], Fe = 1 / de(ls((Ce * Pe + Ie * Re) / (We(Ce * Ce + Ie * Ie) * We(Pe * Pe + Re * Re))) / 2), we = We(te[0] * te[0] + te[1] * te[1]);
              D = Kn(T, (g - we) / (Fe - 1)), F = Kn(T, (_ - we) / (Fe + 1));
            }
          }
          w > 1e-12 ? F > 1e-12 ? (d = mn(Xe, Oe, O, ne, _, F, v), p = mn(se, ve, ie, ue, _, F, v), l.moveTo(d.cx + d.x01, d.cy + d.y01), F < T ? l.arc(d.cx, d.cy, F, ae(d.y01, d.x01), ae(p.y01, p.x01), !v) : (l.arc(d.cx, d.cy, F, ae(d.y01, d.x01), ae(d.y11, d.x11), !v), l.arc(0, 0, _, ae(d.cy + d.y11, d.cx + d.x11), ae(p.cy + p.y11, p.cx + p.x11), !v), l.arc(p.cx, p.cy, F, ae(p.y11, p.x11), ae(p.y01, p.x01), !v))) : (l.moveTo(O, ne), l.arc(0, 0, _, j, M, !v)) : l.moveTo(O, ne), g > 1e-12 && I > 1e-12 ? D > 1e-12 ? (d = mn(ie, ue, se, ve, g, -D, v), p = mn(O, ne, Xe, Oe, g, -D, v), l.lineTo(d.cx + d.x01, d.cy + d.y01), D < T ? l.arc(d.cx, d.cy, D, ae(d.y01, d.x01), ae(p.y01, p.x01), !v) : (l.arc(d.cx, d.cy, D, ae(d.y01, d.x01), ae(d.y11, d.x11), !v), l.arc(0, 0, g, ae(d.cy + d.y11, d.cx + d.x11), ae(p.cy + p.y11, p.cx + p.x11), v), l.arc(p.cx, p.cy, D, ae(p.y11, p.x11), ae(p.y01, p.x01), !v))) : l.arc(0, 0, g, k, E, v) : l.lineTo(ie, ue);
        }
      else
        l.moveTo(0, 0);
      if (l.closePath(), y)
        return l = null, y + "" || null;
    }
    return f.centroid = function() {
      var y = (+o.apply(this, arguments) + +i.apply(this, arguments)) / 2, b = (+u.apply(this, arguments) + +c.apply(this, arguments)) / 2 - un / 2;
      return [Me(b) * y, de(b) * y];
    }, f.innerRadius = function(y) {
      return arguments.length ? (o = typeof y == "function" ? y : ce(+y), f) : o;
    }, f.outerRadius = function(y) {
      return arguments.length ? (i = typeof y == "function" ? y : ce(+y), f) : i;
    }, f.cornerRadius = function(y) {
      return arguments.length ? (s = typeof y == "function" ? y : ce(+y), f) : s;
    }, f.padRadius = function(y) {
      return arguments.length ? (a = y == null ? null : typeof y == "function" ? y : ce(+y), f) : a;
    }, f.startAngle = function(y) {
      return arguments.length ? (u = typeof y == "function" ? y : ce(+y), f) : u;
    }, f.endAngle = function(y) {
      return arguments.length ? (c = typeof y == "function" ? y : ce(+y), f) : c;
    }, f.padAngle = function(y) {
      return arguments.length ? (h = typeof y == "function" ? y : ce(+y), f) : h;
    }, f.context = function(y) {
      return arguments.length ? (l = y != null ? y : null, f) : l;
    }, f;
  }().innerRadius(r - e.ringWidth - e.ringInset).outerRadius(r - e.ringInset).startAngle((o, i) => {
    const s = Tn(n, i);
    return Cr(e.minAngle + s * t);
  }).endAngle((o, i) => {
    const s = Tn(n, i + 1);
    return Cr(e.minAngle + s * t);
  });
}), Yr = ({ d3_refs: e, newValue: n, config: t }) => {
  const r = Tt(t)(n), o = t.maxAngle - t.minAngle, i = t.minAngle + r * o;
  e.pointer.transition(function({ duration: s, ease: a }) {
    return Ro().duration(s).ease(a);
  }({ duration: t.needleTransitionDuration, ease: ju(t.needleTransition) })).attr("transform", `rotate(${i})`), e.current_value_text.text(function(s, a) {
    const u = a.labelFormat(s), c = a.currentValuePlaceholderStyle;
    return a.currentValueText.replace(c, u);
  }(n, t));
}, Nu = ({ container: e, config: n }) => {
  const t = function(i) {
    return i.width / 2;
  }(n), r = function(i, s, a) {
    return `translate(${i + s}, ${i + a})`;
  }(t, n.paddingHorizontal, n.paddingVertical), o = function({ container: i, config: s }) {
    const a = s.width + 2 * s.paddingHorizontal, u = s.height + 2 * s.paddingVertical;
    return uo(i).append("svg:svg").attr("class", "speedometer").attr("width", `${a}${s.dimensionUnit}`).attr("height", `${u}${s.dimensionUnit}`).attr("role", "img").attr("focusable", "false").attr("aria-label", s.svgAriaLabel).style("width", `${a}${s.dimensionUnit}`).style("height", `${u}${s.dimensionUnit}`);
  }({ container: e, config: n });
  return function({ config: i, svg: s, centerTx: a }) {
    const u = St(i), c = Au(i);
    s.append("g").attr("class", "arc").attr("transform", a).selectAll("path").data(u).enter().append("path").attr("class", "speedo-segment").attr("fill", (h, l) => !vt(i.segmentColors) && i.segmentColors[l] ? i.segmentColors[l] : i.arcColorFn(h * l)).attr("d", c);
  }({ config: n, svg: o, centerTx: r }), function({ config: i, svg: s, centerTx: a, r: u }) {
    const c = ku(i), h = St(i), l = Tt(i), f = i.maxAngle - i.minAngle, { customSegmentLabels: y } = i, b = Et(y) && !vt(y), g = b && y.length === h.length;
    if (b && !g)
      throw new Error(`Custom Segment Labels should be an array with length of ${h.length}`);
    if (b && g)
      return void function({ config: _, svg: S, centerTx: x, r: C, ticks: v, tickData: d, scale: p, range: j }) {
        const { customSegmentStops: M, customSegmentLabels: E } = _;
        function k(T, D) {
          const F = M.length === 0 ? p(T) : Tn(d, D);
          return _.minAngle + F * j;
        }
        const I = E.map((T, D) => {
          const F = D, Z = D + 1, oe = k(v[F], F);
          return (k(v[Z], Z) + oe) / 2;
        }), w = C - _.ringWidth - _.ringInset, N = C - _.ringInset, R = N - (N - w) / 2;
        S.append("g").attr("class", "label").attr("transform", x).selectAll("text").data(E).enter().append("text").attr("transform", (T, D) => {
          const F = I[D], Z = `rotate(${F}) translate(0, ${_.labelInset - C})`, oe = `rotate(${F}) translate(0, ${_.labelInset / 2 - R})`;
          return T.position === "OUTSIDE" ? Z : oe;
        }).text((T) => T.text || "").attr("class", "segment-value").style("text-anchor", "middle").style("font-size", (T) => T.fontSize || _.labelFontSize).style("font-weight", "bold").style("fill", (T) => T.color || _.textColor);
      }({ config: i, svg: s, centerTx: a, r: u, ticks: c, tickData: h, scale: l, range: f });
    s.append("g").attr("class", "label").attr("transform", a).selectAll("text").data(c).enter().append("text").attr("transform", (_, S) => {
      const x = i.customSegmentStops.length === 0 ? l(_) : Tn(h, S);
      return `rotate(${i.minAngle + x * f}) translate(0, ${i.labelInset - u})`;
    }).text((_) => i.segmentValueFormatter(i.labelFormat(_))).attr("class", "segment-value").style("text-anchor", "middle").style("font-size", i.labelFontSize).style("font-weight", "bold").style("fill", i.textColor);
  }({ config: n, svg: o, centerTx: r, r: t }), { current_value_text: $u({ config: n, svg: o }), pointer: Tu({ config: n, svg: o, r: t, centerTx: r }) };
};
function $u({ config: e, svg: n }) {
  const t = (e.width + 2 * e.paddingHorizontal) / 2, r = (e.width + 4 * e.paddingVertical) / 2;
  return n.append("g").attr("transform", `translate(${t}, ${r})`).append("text").attr("class", "current-value").attr("text-anchor", "middle").attr("y", 23).text(e.currentValue).style("font-size", e.valueTextFontSize).style("font-weight", e.valueTextFontWeight).style("fill", e.textColor);
}
function Tu({ config: e, svg: n, r: t, centerTx: r }) {
  const o = function({ heightRatio: a, radius: u }) {
    if (a < 0 || a > 1)
      throw new Error(`Invalid needleHeightRatio given - ${a}`);
    return Math.round(u * a);
  }({ heightRatio: e.needleHeightRatio, radius: t }), i = [[e.pointerWidth / 2, 0], [0, -o], [-e.pointerWidth / 2, 0], [0, e.pointerTailLength], [e.pointerWidth / 2, 0]], s = _s().curve(ws);
  return n.append("g").data([i]).attr("class", "pointer").attr("transform", r).style("fill", e.needleColor).append("path").attr("d", s).attr("transform", `rotate(${e.minAngle})`);
}
var Xr, Lo = { exports: {} }, Ke = {}, Qr, vn = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function Cu() {
  return Qr || (Qr = 1, process.env.NODE_ENV !== "production" && (() => {
    var e = Gr, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), a = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), l = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), b = Symbol.iterator, g = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function _(m) {
      for (var $ = arguments.length, A = new Array($ > 1 ? $ - 1 : 0), z = 1; z < $; z++)
        A[z - 1] = arguments[z];
      S("error", m, A);
    }
    function S(m, $, A) {
      var z = g.ReactDebugCurrentFrame.getStackAddendum();
      z !== "" && ($ += "%s", A = A.concat([z]));
      var L = A.map((W) => String(W));
      L.unshift("Warning: " + $), Function.prototype.apply.call(console[m], console, L);
    }
    var x = Symbol.for("react.module.reference");
    function C(m) {
      return m.displayName || "Context";
    }
    function v(m) {
      if (m == null)
        return null;
      if (typeof m.tag == "number" && _("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof m == "function")
        return m.displayName || m.name || null;
      if (typeof m == "string")
        return m;
      switch (m) {
        case r:
          return "Fragment";
        case t:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case c:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof m == "object")
        switch (m.$$typeof) {
          case a:
            return C(m) + ".Consumer";
          case s:
            return C(m._context) + ".Provider";
          case u:
            return function(W, B, X) {
              var K = W.displayName;
              if (K)
                return K;
              var re = B.displayName || B.name || "";
              return re !== "" ? X + "(" + re + ")" : X;
            }(m, m.render, "ForwardRef");
          case l:
            var $ = m.displayName || null;
            return $ !== null ? $ : v(m.type) || "Memo";
          case f:
            var A = m, z = A._payload, L = A._init;
            try {
              return v(L(z));
            } catch {
              return null;
            }
        }
      return null;
    }
    var d, p, j, M, E, k, I, w = Object.assign, N = 0;
    function R() {
    }
    R.__reactDisabledLog = !0;
    var T, D = g.ReactCurrentDispatcher;
    function F(m, $, A) {
      if (T === void 0)
        try {
          throw Error();
        } catch (L) {
          var z = L.stack.trim().match(/\n( *(at )?)/);
          T = z && z[1] || "";
        }
      return `
` + T + m;
    }
    var Z, oe = !1, O = typeof WeakMap == "function" ? WeakMap : Map;
    function ne(m, $) {
      if (!m || oe)
        return "";
      var A, z = Z.get(m);
      if (z !== void 0)
        return z;
      oe = !0;
      var L, W = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0, L = D.current, D.current = null, function() {
        if (N === 0) {
          d = console.log, p = console.info, j = console.warn, M = console.error, E = console.group, k = console.groupCollapsed, I = console.groupEnd;
          var U = { configurable: !0, enumerable: !0, value: R, writable: !0 };
          Object.defineProperties(console, { info: U, log: U, warn: U, error: U, group: U, groupCollapsed: U, groupEnd: U });
        }
        N++;
      }();
      try {
        if ($) {
          var B = () => {
            throw Error();
          };
          if (Object.defineProperty(B.prototype, "props", { set: () => {
            throw Error();
          } }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(B, []);
            } catch (U) {
              A = U;
            }
            Reflect.construct(m, [], B);
          } else {
            try {
              B.call();
            } catch (U) {
              A = U;
            }
            m.call(B.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (U) {
            A = U;
          }
          m();
        }
      } catch (U) {
        if (U && A && typeof U.stack == "string") {
          for (var X = U.stack.split(`
`), K = A.stack.split(`
`), re = X.length - 1, G = K.length - 1; re >= 1 && G >= 0 && X[re] !== K[G]; )
            G--;
          for (; re >= 1 && G >= 0; re--, G--)
            if (X[re] !== K[G]) {
              if (re !== 1 || G !== 1)
                do
                  if (re--, --G < 0 || X[re] !== K[G]) {
                    var V = `
` + X[re].replace(" at new ", " at ");
                    return m.displayName && V.includes("<anonymous>") && (V = V.replace("<anonymous>", m.displayName)), typeof m == "function" && Z.set(m, V), V;
                  }
                while (re >= 1 && G >= 0);
              break;
            }
        }
      } finally {
        oe = !1, D.current = L, function() {
          if (--N == 0) {
            var U = { configurable: !0, enumerable: !0, writable: !0 };
            Object.defineProperties(console, { log: w({}, U, { value: d }), info: w({}, U, { value: p }), warn: w({}, U, { value: j }), error: w({}, U, { value: M }), group: w({}, U, { value: E }), groupCollapsed: w({}, U, { value: k }), groupEnd: w({}, U, { value: I }) });
          }
          N < 0 && _("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }(), Error.prepareStackTrace = W;
      }
      var ee = m ? m.displayName || m.name : "", P = ee ? F(ee) : "";
      return typeof m == "function" && Z.set(m, P), P;
    }
    function ie(m, $, A) {
      if (m == null)
        return "";
      if (typeof m == "function")
        return ne(m, !(!(z = m.prototype) || !z.isReactComponent));
      var z;
      if (typeof m == "string")
        return F(m);
      switch (m) {
        case c:
          return F("Suspense");
        case h:
          return F("SuspenseList");
      }
      if (typeof m == "object")
        switch (m.$$typeof) {
          case u:
            return ne(m.render, !1);
          case l:
            return ie(m.type, $, A);
          case f:
            var L = m, W = L._payload, B = L._init;
            try {
              return ie(B(W), $, A);
            } catch {
            }
        }
      return "";
    }
    Z = new O();
    var ue = Object.prototype.hasOwnProperty, te = {}, se = g.ReactDebugCurrentFrame;
    function ve(m) {
      if (m) {
        var $ = m._owner, A = ie(m.type, m._source, $ ? $.type : null);
        se.setExtraStackFrame(A);
      } else
        se.setExtraStackFrame(null);
    }
    var Xe = Array.isArray;
    function Oe(m) {
      return Xe(m);
    }
    function Ce(m) {
      return "" + m;
    }
    function Ie(m) {
      if (function($) {
        try {
          return Ce($), !1;
        } catch {
          return !0;
        }
      }(m))
        return _("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", function($) {
          return typeof Symbol == "function" && Symbol.toStringTag && $[Symbol.toStringTag] || $.constructor.name || "Object";
        }(m)), Ce(m);
    }
    var Pe, Re, Fe, we = g.ReactCurrentOwner, zo = { key: !0, ref: !0, __self: !0, __source: !0 };
    Fe = {};
    function Wo(m, $, A, z, L) {
      var W, B = {}, X = null, K = null;
      for (W in A !== void 0 && (Ie(A), X = "" + A), function(V) {
        if (ue.call(V, "key")) {
          var ee = Object.getOwnPropertyDescriptor(V, "key").get;
          if (ee && ee.isReactWarning)
            return !1;
        }
        return V.key !== void 0;
      }($) && (Ie($.key), X = "" + $.key), function(V) {
        if (ue.call(V, "ref")) {
          var ee = Object.getOwnPropertyDescriptor(V, "ref").get;
          if (ee && ee.isReactWarning)
            return !1;
        }
        return V.ref !== void 0;
      }($) && (K = $.ref, function(V, ee) {
        if (typeof V.ref == "string" && we.current && ee && we.current.stateNode !== ee) {
          var P = v(we.current.type);
          Fe[P] || (_('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', v(we.current.type), V.ref), Fe[P] = !0);
        }
      }($, L)), $)
        ue.call($, W) && !zo.hasOwnProperty(W) && (B[W] = $[W]);
      if (m && m.defaultProps) {
        var re = m.defaultProps;
        for (W in re)
          B[W] === void 0 && (B[W] = re[W]);
      }
      if (X || K) {
        var G = typeof m == "function" ? m.displayName || m.name || "Unknown" : m;
        X && function(V, ee) {
          var P = () => {
            Pe || (Pe = !0, _("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ee));
          };
          P.isReactWarning = !0, Object.defineProperty(V, "key", { get: P, configurable: !0 });
        }(B, G), K && function(V, ee) {
          var P = () => {
            Re || (Re = !0, _("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ee));
          };
          P.isReactWarning = !0, Object.defineProperty(V, "ref", { get: P, configurable: !0 });
        }(B, G);
      }
      return ((V, ee, P, U, Qe, Ge, Yo) => {
        var De = { $$typeof: n, type: V, key: ee, ref: P, props: Yo, _owner: Ge, _store: {} };
        return Object.defineProperty(De._store, "validated", { configurable: !1, enumerable: !1, writable: !0, value: !1 }), Object.defineProperty(De, "_self", { configurable: !1, enumerable: !1, writable: !1, value: U }), Object.defineProperty(De, "_source", { configurable: !1, enumerable: !1, writable: !1, value: Qe }), Object.freeze && (Object.freeze(De.props), Object.freeze(De)), De;
      })(m, X, K, L, z, we.current, B);
    }
    var qn, Ln = g.ReactCurrentOwner, Ct = g.ReactDebugCurrentFrame;
    function Ve(m) {
      if (m) {
        var $ = m._owner, A = ie(m.type, m._source, $ ? $.type : null);
        Ct.setExtraStackFrame(A);
      } else
        Ct.setExtraStackFrame(null);
    }
    function zn(m) {
      return typeof m == "object" && m !== null && m.$$typeof === n;
    }
    function It() {
      if (Ln.current) {
        var m = v(Ln.current.type);
        if (m)
          return `

Check the render method of \`` + m + "`.";
      }
      return "";
    }
    qn = !1;
    var Pt = {};
    function Rt(m, $) {
      if (m._store && !m._store.validated && m.key == null) {
        m._store.validated = !0;
        var A = function(L) {
          var W = It();
          if (!W) {
            var B = typeof L == "string" ? L : L.displayName || L.name;
            B && (W = `

Check the top-level render call using <` + B + ">.");
          }
          return W;
        }($);
        if (!Pt[A]) {
          Pt[A] = !0;
          var z = "";
          m && m._owner && m._owner !== Ln.current && (z = " It was passed a child from " + v(m._owner.type) + "."), Ve(m), _('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', A, z), Ve(null);
        }
      }
    }
    function Ft(m, $) {
      if (typeof m == "object") {
        if (Oe(m))
          for (var A = 0; A < m.length; A++) {
            var z = m[A];
            zn(z) && Rt(z, $);
          }
        else if (zn(m))
          m._store && (m._store.validated = !0);
        else if (m) {
          var L = function(X) {
            if (X === null || typeof X != "object")
              return null;
            var K = b && X[b] || X["@@iterator"];
            return typeof K == "function" ? K : null;
          }(m);
          if (typeof L == "function" && L !== m.entries)
            for (var W, B = L.call(m); !(W = B.next()).done; )
              zn(W.value) && Rt(W.value, $);
        }
      }
    }
    function Bo(m) {
      var $, A = m.type;
      if (A != null && typeof A != "string") {
        if (typeof A == "function")
          $ = A.propTypes;
        else {
          if (typeof A != "object" || A.$$typeof !== u && A.$$typeof !== l)
            return;
          $ = A.propTypes;
        }
        if ($) {
          var z = v(A);
          (function(L, W, B, X, K) {
            var re = Function.call.bind(ue);
            for (var G in L)
              if (re(L, G)) {
                var V = void 0;
                try {
                  if (typeof L[G] != "function") {
                    var ee = Error((X || "React class") + ": " + B + " type `" + G + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof L[G] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    throw ee.name = "Invariant Violation", ee;
                  }
                  V = L[G](W, G, X, B, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
                } catch (P) {
                  V = P;
                }
                !V || V instanceof Error || (ve(K), _("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", X || "React class", B, G, typeof V), ve(null)), V instanceof Error && !(V.message in te) && (te[V.message] = !0, ve(K), _("Failed %s type: %s", B, V.message), ve(null));
              }
          })($, m.props, "prop", z, m);
        } else
          A.PropTypes !== void 0 && !qn && (qn = !0, _("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", v(A) || "Unknown"));
        typeof A.getDefaultProps != "function" || A.getDefaultProps.isReactClassApproved || _("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vt(m, $, A, z, L, W) {
      var B = function(P) {
        return typeof P == "string" || typeof P == "function" || P === r || P === i || P === o || P === c || P === h || P === y || typeof P == "object" && P !== null && (P.$$typeof === f || P.$$typeof === l || P.$$typeof === s || P.$$typeof === a || P.$$typeof === u || P.$$typeof === x || P.getModuleId !== void 0);
      }(m);
      if (!B) {
        var X = "";
        (m === void 0 || typeof m == "object" && m !== null && Object.keys(m).length === 0) && (X += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
        var K, re = function(P) {
          return P !== void 0 ? `

Check your code at ` + P.fileName.replace(/^.*[\\\/]/, "") + ":" + P.lineNumber + "." : "";
        }(L);
        X += re || It(), m === null ? K = "null" : Oe(m) ? K = "array" : m !== void 0 && m.$$typeof === n ? (K = "<" + (v(m.type) || "Unknown") + " />", X = " Did you accidentally export a JSX literal instead of a component?") : K = typeof m, _("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", K, X);
      }
      var G = Wo(m, $, A, L, W);
      if (G == null)
        return G;
      if (B) {
        var V = $.children;
        if (V !== void 0)
          if (z)
            if (Oe(V)) {
              for (var ee = 0; ee < V.length; ee++)
                Ft(V[ee], m);
              Object.freeze && Object.freeze(V);
            } else
              _("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
          else
            Ft(V, m);
      }
      return m === r ? function(P) {
        for (var U = Object.keys(P.props), Qe = 0; Qe < U.length; Qe++) {
          var Ge = U[Qe];
          if (Ge !== "children" && Ge !== "key") {
            Ve(P), _("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ge), Ve(null);
            break;
          }
        }
        P.ref !== null && (Ve(P), _("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }(G) : Bo(G), G;
    }
    var Uo = function(m, $, A) {
      return Vt(m, $, A, !1);
    }, Ho = function(m, $, A) {
      return Vt(m, $, A, !0);
    };
    vn.Fragment = r, vn.jsx = Uo, vn.jsxs = Ho;
  })()), vn;
}
((e) => {
  process.env.NODE_ENV === "production" ? e.exports = function() {
    if (Xr)
      return Ke;
    Xr = 1;
    var n = Gr, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, i = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
    function a(u, c, h) {
      var l, f = {}, y = null, b = null;
      for (l in h !== void 0 && (y = "" + h), c.key !== void 0 && (y = "" + c.key), c.ref !== void 0 && (b = c.ref), c)
        o.call(c, l) && !s.hasOwnProperty(l) && (f[l] = c[l]);
      if (u && u.defaultProps)
        for (l in c = u.defaultProps)
          f[l] === void 0 && (f[l] = c[l]);
      return { $$typeof: t, type: u, key: y, ref: b, props: f, _owner: i.current };
    }
    return Ke.Fragment = r, Ke.jsx = a, Ke.jsxs = a, Ke;
  }() : e.exports = Cu();
})(Lo);
const Iu = Lo.exports.jsx;
class Ot extends Go {
  constructor(t) {
    super(t);
    Wn(this, "render", () => Iu("div", { ref: (t) => this.gaugeDiv = t }));
    this.d3_refs = { pointer: !1, current_value_text: !1 };
  }
  componentDidMount() {
    this.renderGauge();
  }
  componentDidUpdate() {
    this.props.forceRender ? this.renderGauge() : this.updateReadings();
  }
  renderGauge() {
    this.config = (({ PROPS: t, parentWidth: r, parentHeight: o }) => {
      const i = { width: t.fluidWidth ? r : t.width, height: t.fluidWidth ? o : t.height, paddingHorizontal: t.paddingHorizontal, paddingVertical: t.paddingVertical, dimensionUnit: t.dimensionUnit, ringWidth: t.ringWidth, minValue: t.minValue, maxValue: t.maxValue, needleColor: t.needleColor, majorTicks: t.segments, customSegmentStops: t.customSegmentStops, customSegmentLabels: t.customSegmentLabels, maxSegmentLabels: rs({ maxSegmentLabelCount: t.maxSegmentLabels, segmentCount: t.segments }), segmentColors: t.segmentColors, arcColorFn: t.segmentColors.length > 0 ? _o(t.segmentColors) : la(sn(t.startColor), sn(t.endColor)), needleTransition: t.needleTransition, needleTransitionDuration: t.needleTransitionDuration, needleHeightRatio: t.needleHeightRatio, textColor: t.textColor, labelFormat: jn(t.valueFormat), segmentValueFormatter: t.segmentValueFormatter, currentValueText: t.currentValueText, currentValuePlaceholderStyle: t.currentValuePlaceholderStyle, labelFontSize: t.labelFontSize, valueTextFontSize: t.valueTextFontSize, valueTextFontWeight: t.valueTextFontWeight, svgAriaLabel: t.svgAriaLabel };
      return Object.assign({}, as, i);
    })({ PROPS: this.props, parentWidth: this.gaugeDiv.parentNode.clientWidth, parentHeight: this.gaugeDiv.parentNode.clientHeight }), uo(this.gaugeDiv).select("svg").remove(), this.d3_refs = Nu({ container: this.gaugeDiv, config: this.config }), Yr({ d3_refs: this.d3_refs, newValue: this.props.value, config: this.config });
  }
  updateReadings() {
    var t, r;
    this.config = (t = this.config, r = { labelFormat: jn(this.props.valueFormat || ""), segmentValueFormatter: this.props.segmentValueFormatter || $o, currentValueText: this.props.currentValueText || "${value}" }, { ...t, ...r }), Yr({ d3_refs: this.d3_refs, newValue: this.props.value || 0, config: this.config });
  }
}
Wn(Ot, "displayName", "ReactSpeedometer");
Ot.propTypes = { value: q.exports.number.isRequired, minValue: q.exports.number.isRequired, maxValue: q.exports.number.isRequired, forceRender: q.exports.bool.isRequired, width: q.exports.number.isRequired, height: q.exports.number.isRequired, paddingHorizontal: q.exports.number.isRequired, paddingVertical: q.exports.number.isRequired, dimensionUnit: q.exports.string.isRequired, fluidWidth: q.exports.bool.isRequired, segments: q.exports.number.isRequired, maxSegmentLabels: q.exports.number, customSegmentStops: q.exports.array, customSegmentLabels: q.exports.arrayOf(q.exports.shape({ text: q.exports.string, position: q.exports.oneOf(["OUTSIDE", "INSIDE"]), fontSize: q.exports.string, color: q.exports.string })), needleColor: q.exports.string.isRequired, startColor: q.exports.string.isRequired, endColor: q.exports.string.isRequired, segmentColors: q.exports.array.isRequired, needleTransition: q.exports.string.isRequired, needleTransitionDuration: q.exports.number.isRequired, needleHeightRatio: q.exports.number.isRequired, ringWidth: q.exports.number.isRequired, textColor: q.exports.string.isRequired, valueFormat: q.exports.string.isRequired, segmentValueFormatter: q.exports.func, currentValueText: q.exports.string.isRequired, currentValuePlaceholderStyle: q.exports.string.isRequired, labelFontSize: q.exports.string.isRequired, valueTextFontSize: q.exports.string.isRequired, valueTextFontWeight: q.exports.string.isRequired, svgAriaLabel: q.exports.string }, Ot.defaultProps = is;
export {
  Fu as CustomSegmentLabelPosition,
  Y as Transition,
  Ot as default
};
